import { medicalOutOfNetworkBenefits } from "client/src/domain/ExplorerPages/Modals/ExplorerBenefitModal/MedicalOutOfNetworkBenefits";
import { medicalRequiresPcp } from "client/src/domain/ExplorerPages/Modals/ExplorerBenefitModal/MedicalRequiresPcp";
import { medicalSpecialtyCareReferral } from "client/src/domain/ExplorerPages/Modals/ExplorerBenefitModal/MedicalSpecialtyCareReferral";
import { OrthodonticServicesValue } from "client/src/domain/ExplorerPages/Modals/ExplorerBenefitModal/OrthodonticServices";
import type { ExplorerNavBarCopyStructure } from "client/src/components/NavBar/ExplorerNavBar";
import type { ExplorerBenefitCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerBenefit";
import type { ExplorerBenefitADDCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerBenefitADD";
import type { ExplorerBenefitCoverageCalculatorCopyStrucutre } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerBenefitCoverageCalculator";
import type { ExplorerBenefitFaqCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerBenefitFaq";
import type { ExplorerBenefitFindDoctorCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerBenefitFindDoctor";
import type { ExplorerBenefitHelpfulHintCopyStrucutre } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerBenefitHelpfulHint";
import type { ExplorerBenefitHowMuchCoverageCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerBenefitHowMuchCoverage";
import type { ExplorerBenefitHowToUsePlanCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerBenefitHowToUsePlan";
import type { ExplorerBenefitOverviewCopyStrucutre } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerBenefitOverview";
import type { ExplorerBenefitPlansCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerBenefitPlans";
import type { ExplorerBenefitRealWorldCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerBenefitRealWorld";
import type { ExplorerBenefitVideoCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerBenefitVideo";
import type { ExplorerBenefitWellnessCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerBenefitWellness";
import type { ExplorerBenefitWhyNeedItCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerBenefitWhyNeedIt";
import type { ExplorerPlanCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerPlan";
import type { ExplorerPlanComparisonTableCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerPlanComparisonTable";
import type { ExplorerPlanComparisonTableWVClientDentalCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/Benefit/ExplorerPlanComparisonTableWVClientDental";
import type { ExplorerDisclaimersCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/ExplorerDisclaimers";
import type { ExplorerHeadlineCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/ExplorerHeadline";
import type { ExplorerHighlightersCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/ExplorerHighlighters";
import type { PersonalBenefitsPlanHeadlineCopyStructure } from "client/src/domain/ExplorerPages/ClientPage/PersonalBenefitsPlanHeadline";
import type { ExplorerLeadGenerationCopyStructure } from "client/src/domain/ExplorerPages/Modals/ClientPage/ExplorerLeadGenerationModal";
import type { ExplorerLocationModalCopyStructure } from "client/src/domain/ExplorerPages/Modals/ClientPage/ExplorerLocationModal";
import type { ExplorerNewSiteModalCopyStructure } from "client/src/domain/ExplorerPages/Modals/ClientPage/ExplorerNewSiteModal";

export const english = {
  Generic: {
    Yes: "Yes",
    No: "No",
  },
  AlternateNames: {
    CRITICAL_ILLNESS_DEFAULT: "Critical Illness",
    CRITICAL_ILLNESS_NY: "Specified Disease",
    CRITICAL_ILLNESS_CA: "Specified Disease",
    CRITICAL_ILLNESS_CT: "Specified Disease",
    GAP_DEFAULT: 'Hospital Confinement Indemnity "Gap"',
    GAP_CA: 'Supplemental Medical Expense "Gap"',
    GAP_CO: 'Supplemental Medical Expense "Gap"',
    GAP_IN: 'Supplemental Medical Expense "Gap"',
    GAP_OR: 'Supplemental Medical Expense "Gap"',
    GAP_MO: 'Supplemental Medical Expense "Gap"',
    DENTAL_DEFAULT_one: "Dental Plan",
    DENTAL_DEFAULT_inline_one: "a dental plan",
    DENTAL_DEFAULT_other: "Dental Plans",
    DENTAL_ASO_PPO: "Dental Plan",
    DENTAL_ASO_PPO_inline: "a dental plan",
    DENTAL_PPO: "Dental Insurance",
    DENTAL_INDEMNITY: "Dental Insurance",
    DENTAL_DHMO: "Prepaid/DHMO Dental",
    DENTAL_DHMO_TX: "Prepaid Dental",
    DENTAL_DHMO_FL: "Prepaid Dental",
  },
  ExplorerBenefitOverview: {
    MEDICAL: {
      header: "<strong>Medical Insurance</strong>",
      subHeader: "Overview",
      overview:
        "Helps you pay for doctor’s visits, surgeries and other things like prescription drugs.",
    },
    DENTAL: {
      header: "<strong>{{alternateName}}</strong>",
      subHeader: "Overview",
      overview: "Helps you pay for checkups, cleanings, and other procedures.",
      overview_DHMO:
        "Helps you pay for checkups, cleanings, and other procedures. The plans are easy to use with no deductibles, waiting periods or maximums.",
    },
    VISION: {
      header: "<strong>Vision Insurance</strong>",
      subHeader: "Overview",
      overview: "Helps you pay for checkups, glasses, and contacts.",
    },
    ACCIDENT: {
      header: "<strong>Accident Insurance</strong>",
      subHeader: "Overview",
      overview:
        "Helps minimize the financial impact when you have an accident. Receive cash benefits for covered injuries (like a fracture), treatments (such as crutches) and services (like an x-ray).",
    },
    HOSPITAL_INDEMNITY: {
      header: "<strong>Hospital Indemnity Insurance</strong>",
      subHeader: "Overview",
      overview:
        "Helps to protect your finances from costs you may have to pay after a hospital stay.",
    },
    LIFE: {
      header: "<strong>Life{{add}} Insurance</strong>",
      subHeader: "Overview",
      overview: "Financial support for your loved ones when they need it the most.",
      "AD&D": " and Accidental Death & Dismemberment",
    },
    CRITICAL_ILLNESS: {
      header: "<strong>{{alternateName}} Insurance</strong>",
      subHeader: "Overview",
      overview:
        "This plan pays a fixed lump sum after a {{alternateName, lowercase}} diagnosis. Covered conditions may include heart attack, stroke, and more.",
    },
    CANCER: {
      header: "<strong>Cancer Insurance</strong>",
      subHeader: "Overview",
      overview:
        "This plan provides cash benefits for certain cancer treatments and services. You also get a benefit for having a standard cancer screening.",
    },
    FINANCIAL: {
      header: "<strong>Financial Products</strong>",
      subHeader: "Overview",
      overview: "{{clientName}} is also offering {{count}} financial products for you to consider.",
      overview_one: "{{clientName}} is also offering a financial product for you to consider.",
    },
    SHORT_TERM_DISABILITY: {
      header: "<strong>Short-Term Disability Insurance</strong>",
      subHeader: "Overview",
      overview:
        "Financial protection when you need it most. Pays a weekly cash benefit when you can’t work due to a covered disability.",
    },
    LONG_TERM_DISABILITY: {
      header: "<strong>Long-Term Disability Insurance</strong>",
      subHeader: "Overview",
      overview:
        "Financial protection when you need it most. Get a monthly cash benefit if you can’t work due to a covered disability.",
    },
    GAP: {
      header: "<strong>{{alternateName}} Insurance</strong>",
      subHeader: "Overview",
      overview: "Helps with out-of-pocket medical expenses, like deductibles and coinsurance.",
    },
    OTHER: {
      header: "<strong>Additional Benefits</strong>",
      header_one: "<strong>Additional Benefit</strong>",
      subHeader: "Overview",
      overview: "{{clientName}} is also offering {{count}} additional benefits to you.",
      overview_one: "{{clientName}} is also offering an additional benefit to you.",
    },
  },
  ExplorerBenefitVideo: {
    DENTAL: {
      videoID: "fZRWdigh2xhhCzK6tsKQK1",
      videoID_DHMO: "7owVkFrYCBCRHRXngDwBtA",
      name: "Why having a dental plan is important",
      name_PPO: "Why dental insurance is important",
      watchTime: "1 min. watch",
    },
    VISION: {
      videoID: "x8MgKm2A9EgmzXV7B6qgy5",
      name: "Why vision insurance is important",
      watchTime: "1 min. watch",
    },
    ACCIDENT: {
      videoID: "W5g3gUAvBrESYMNKNYLCgn",
      name: "Why accident insurance is important",
      watchTime: "1 min. watch",
    },
    CRITICAL_ILLNESS: {
      videoID: "6J5ZVeSpGouY88KoN9BeCj",
      name: "Why {{alternateName}} insurance is important",
      watchTime: "1 min. watch",
    },
    HOSPITAL_INDEMNITY: {
      videoID: "Y7w9WPJN6d1WEsLdEVYxkj",
      name: "Why hospital indemnity insurance is important",
      watchTime: "1 min. watch",
    },
    CANCER: {
      videoID: "EtnT9j3f1DmjHxVnjVvWjR",
      name: "Why cancer insurance is important",
      watchTime: "1 min. watch",
    },
    GAP: {
      videoID: "L3gb26jcUeNyhTd44mhxkN",
      name: "Why gap insurance is important",
      watchTime: "1 min. watch",
    },
    LONG_TERM_DISABILITY: {
      videoID: "DbvxbK73igs9JMH59D4qVX",
      name: "Why long-term disability insurance is important",
      watchTime: "1 min. watch",
    },
    SHORT_TERM_DISABILITY: {
      videoID: "dZreUpFR8UragPqxVmV12B",
      name: "Why short-term disability insurance is important",
      watchTime: "1 min. watch",
    },
    LIFE: {
      videoID: "Ke6czr3LNqNjy8N19ijucr",
      name: "Why life insurance is important",
      watchTime: "1 min. watch",
    },
  },
  ExplorerBenefitWhyNeedIt: {
    header: "Why you might need it",
    MEDICAL: {
      description:
        "Most of us don’t have the savings needed to cover the full cost of a serious accident or illness. Having medical insurance can help protect you from those high costs.",
    },
    DENTAL: {
      description:
        "Most dentists recommend that you get your teeth cleaned two times a year. The costs of those procedures can add up quickly. Having a dental plan can help you with those costs while you take care of your teeth.",
    },
    VISION: {
      description:
        "Your vision can influence many of your daily activities such as reading, driving, or playing a sport. If your vision is not optimal, it could change your quality of life. The costs of exams, glasses or contacts can add up quickly. Having a vision plan can help you with those costs while you take care of your eyesight.",
    },
    ACCIDENT: {
      description:
        "It’s an extra layer of financial protection when an unexpected accident happens. An accident could happen when playing a sport, driving to the store, or just working around the house. The costs can add up very quickly and could be thousands of dollars on top of your daily expenses.",
    },
    HOSPITAL_INDEMNITY: {
      description:
        "Whether planned or not, a hospital stay can quickly leave you with high medical bills. This is often thousands of dollars, on top of daily expenses. <br /><br /> Benefits are payable for hospital stays due to things like sickness, accidents, pregnancy complications and more. Plus, these cash benefits are in addition to your health insurance.",
    },
    LIFE: {
      description:
        "Add life{{add}} insurance if you have any debt or loved ones who rely on your income. Some things to consider are housing costs, daily expenses, or future education needs. Your beneficiaries can use the payout for anything. The extra cash in their pocket can relieve stress during a difficult time.",
      "AD&D": " and accidental death & dismemberment (AD&D)",
    },
    CRITICAL_ILLNESS: {
      description:
        "A {{alternateName, lowercase}} diagnosis could easily have you owing the out-of-pocket max on your medical plan. This is often thousands of dollars, on top of your everyday expenses. A {{alternateName, lowercase}} plan offers financial protection that supports you through a serious illness, such as:",
      bulletPoints: ["Heart Attack", "Major Organ Failure", "COVID-19", "Stroke", "and many more"],
      bulletPoints_DC: ["Heart Attack", "Major Organ Failure", "Stroke", "and many more"],
      bulletPoints_NY: ["Heart Attack", "Major Organ Failure", "Stroke", "and many more"],
      bulletPoints_NJ: ["Heart Attack", "Major Organ Failure", "Stroke", "and many more"],
      bulletPoints_ID: [
        "Heart Attack",
        "Major Organ Failure",
        "COVID-19 (no hospital stay)",
        "Stroke",
        "and many more",
      ],
    },
    CANCER: {
      description:
        "A cancer diagnosis can bring a lot of stress. This benefit helps you prepare financially for the out-of-pocket costs for treatments and services. It offers fixed benefits for things like screenings, surgery, or chemo.<br /><br /> You can use the payment for anything. It can help with costs not covered by your health insurance or everyday expenses. Plus, the payments are in addition to your health insurance.",
    },
    SHORT_TERM_DISABILITY: {
      description:
        "About 25% of people who are 20 years old today will have a disability at some point during their career.<sup>1</sup> Many people don’t have enough money in their savings to cover expenses when they can’t work. Short-Term Disability (STD) insurance<sup>2</sup> replaces a portion of your income when you are unable to work due to a covered disability. <br /><br /> Some commonly covered disabilities are:",
      bulletPoints: ["Pregnancy", "Injuries", "Back disorders", "And many more"],
    },
    LONG_TERM_DISABILITY: {
      description:
        "34.6 months is the length of the average long-term disability claim.<sup>1</sup> An extended period when you can’t work can cause financial stress. Long-Term Disability (LTD) insurance replaces part of your income when you are unable to work. <br /><br /> Some commonly covered disabilities include:",
      bulletPoints: ["Cancer", "Injuries", "Nervous system disorders", "And many more"],
    },
    GAP: {
      description:
        "Most medical insurance plans don’t pay 100% these days. There are still out-of-pocket costs you might not have planned. In fact, if you have a high deductible plan, just the deductible alone can cost you thousands of dollars. <br/><br/> Gap Insurance helps cover the difference between the benefits paid by your medical insurance and the actual expenses incurred.",
    },
  },
  ExplorerBenefitPlans: {
    header_one: "Review your available plan",
    header_other: "Review your available plans",
  },
  ExplorerPlan: {
    downloadPDF: "Download plan summary (PDF)",
    unfavoriteConfirmBody: "Are you sure you want to remove the plan from favorites?",
    unfavoriteTitle: "Delete favorite plan",
    unfavoriteConfirmText: "Remove",
    unfavoriteCancelText: "Cancel",
    newPlanText: "NEW PLAN",
    MEDICAL: {
      HDHP: "<p>This plan is a High Deductible Health Plan (HDHP). It has a higher deductible than a traditional {{planType}} plan. You will pay less for the monthly premium, but more for healthcare costs before you hit the deductible.</p>",
      HSA_addon: "<p>You can have a health savings account (HSA) with this plan.</p>",
      HMO: {
        default: {
          default: {
            subHeading: "HMO Plan (Health Maintenance Organization)",
            content:
              "<p>With this plan you will need to choose a doctor within the network who will coordinate your care. HMO plans don’t usually cover out-of-network services unless it is an emergency.</p>",
          },
        },
      },
      PPO: {
        default: {
          default: {
            subHeading: "PPO Plan (Preferred Provider Organization)",
            content:
              "<p>With this type of plan you can see any doctor you choose, but you can save money when you stay in-network.</p>",
          },
        },
      },
      EPO: {
        default: {
          default: {
            subHeading: "EPO Plan (Exclusive Provider Organization)",
            content:
              "<p>With this plan you must access care within the network. If you seek care outside the network, it typically won’t be covered.</p>",
          },
        },
      },
      MEC: {
        default: {
          default: {
            subHeading: "MEC Plan (Minimum Essential Coverage)",
            content:
              "<p>These plans can range from only covering preventive and wellness services to also including some doctor visits and ER services. Make sure to review the plan being offered carefully so that you know exactly what services are covered.</p>",
          },
        },
      },
      POS: {
        default: {
          default: {
            subHeading: "POS Plan (Point of Service)",
            content:
              "<p>You can pay less for care if you use doctors within your network for this type of plan. A referral is required from your primary care doctor to see a specialist.</p>",
          },
        },
      },
      OAP: {
        default: {
          default: {
            subHeading: "OAP (Open Access Plan)",
            content:
              "<p>With this plan you can see the doctor or specialist you choose without needing a referral, but they must be in the network. If you seek care outside the network, it may not be covered, or it will typically cost more.</p>",
          },
        },
      },
    },
    DENTAL: {
      PPO: {
        default: {
          default: {
            subHeading: "PPO Plan (Preferred Provider Organization)",
            content: `
              <p>
                You can see any doctor you choose, but you can save money when you stay in-network. Typically, your dentist will file claims for you and then you will pay your portion based on your plan.
              </p>
              <0>Consider this plan if:</0>
              <1>
                <0>
                  You are concerned about the cost of maintaining your healthy smile 
                </0>
                <0>
                  You have any upcoming procedures that will require multiple visits to the dentist.
                </0>
              </1>
            `,
            content_MULTI_CHOICE: `
              <p>
                You can see any doctor you choose, but you can save money when you stay in-network. Typically, your dentist will file claims for you and then you will pay your portion based on your plan.
              </p>
              <0>Consider this plan if:</0>
              <1>
                <0>
                  Your family is in more than one location and you need the flexibility to go to any dentist. 
                </0>
                <0>
                  There are services not covered in the copay schedule that you will need.
                </0>
              </1>
            `,
          },
          LOW_HIGH: {
            subHeading: "PPO Plan (Preferred Provider Organization)",
            content: `
              <p>
              You can see any doctor you choose, but you can save money when you stay in-network. Typically, your dentist will file claims for you and then you will pay your portion based on your plan. 
              </p>
              <p>Your employer is offering you a choice of plans. Please review the plan summary for information about both plans and choose the one plan that best fits your needs.</p>
              <0>Consider this plan if:</0>
              <1>
                <0>
                  You are concerned about the cost of maintaining your healthy smile 
                </0>
                <0>
                  You have any upcoming procedures that will require multiple visits to the dentist.
                </0>
              </1>
            `,
            content_MULTI_CHOICE: `
              <p>
              You can see any doctor you choose, but you can save money when you stay in-network. Typically, your dentist will file claims for you and then you will pay your portion based on your plan. 
              </p>
              <p>Your employer is offering you a choice of plans. Please review the plan summary for information about both plans and choose the one plan that best fits your needs.</p>
              <0>Consider this plan if:</0>
              <1>
                <0>
                  Your family is in more than one location and you need the flexibility to go to any dentist.
                </0>
                <0>
                  There are services not covered in the copay schedule that you will need.
                </0>
              </1>`,
          },
          grouped: {
            heading: "{{carrier}} Dental PPO Plans",
            subHeading: "PPO Plan (Preferred Provider Organization)",
            content: `
                <p>
                  You can see any doctor you choose, but you can save money when you stay in-network. Typically, your dentist will file claims for you and then you will pay your portion based on your plan.
                </p>
                <p>Your employer is offering you a choice of plans. Please review the plan summary for information about both plans and choose the one plan that best fits your needs.</p>
                <0>Consider these plans if:</0>
                <1>
                  <0>
                    You are concerned about the cost of maintaining your healthy smile 
                  </0>
                  <0>
                    You have any upcoming procedures that will require multiple visits to the dentist.
                  </0>
                </1>
              `,
            groupedSubHeading:
              "There are a few different types of PPO plans for you to choose from:",
            groupedContent:
              "For more information about how these plans differ you can look at the plan comparison table or download the plan summaries.",
          },
        },
      },
      ASO_PPO: {
        default: {
          default: {
            subHeading: "PPO Plan (Preferred Provider Organization)",
            content: `
              <p>
                You can see any doctor you choose, but you can save money when you stay in-network. Typically, your dentist will file claims for you and then you will pay your portion based on your plan. 
              </p>
              <0>Consider this plan if:</0>
              <1>
                <0>
                  You are concerned about the cost of maintaining your healthy smile 
                </0>
                <0>
                  You have any upcoming procedures that will require multiple visits to the dentist.
                </0>
              </1>
            `,
            content_MULTI_CHOICE: `
              <p>
                You can see any doctor you choose, but you can save money when you stay in-network. Typically, your dentist will file claims for you and then you will pay your portion based on your plan. 
              </p>
              <0>Consider this plan if:</0>
              <1>
                <0>
                  Your family is in more than one location and you need the flexibility to go to any dentist.
                </0>
                <0>
                  There are services not covered in the copay schedule that you will need.
                </0>
              </1>
            `,
          },
          LOW_HIGH: {
            subHeading: "PPO Plan (Preferred Provider Organization)",
            content: `
              <p>
                You can see any doctor you choose, but you can save money when you stay in-network. Typically, your dentist will file claims for you and then you will pay your portion based on your plan. 
              </p>
              <p>Your employer is offering you a choice of plans. Please review the plan summary for information about both plans and choose the one plan that best fits your needs.</p>
              <0>Consider this plan if:</0>
              <1>
                <0>
                  You are concerned about the cost of maintaining your healthy smile 
                </0>
                <0>
                  You have any upcoming procedures that will require multiple visits to the dentist.
                </0>
              </1>
            `,
            content_MULTI_CHOICE: `
              <p>
                You can see any doctor you choose, but you can save money when you stay in-network. Typically, your dentist will file claims for you and then you will pay your portion based on your plan. 
              </p>
              <p>Your employer is offering you a choice of plans. Please review the plan summary for information about both plans and choose the one plan that best fits your needs.</p>
              <0>Consider this plan if:</0>
              <1>
                <0>
                  Your family is in more than one location and you need the flexibility to go to any dentist.
                </0>
                <0>
                  There are services not covered in the copay schedule that you will need.
                </0>
              </1>
            `,
          },
        },
      },
      INDEMNITY: {
        default: {
          default: {
            subHeading: "Indemnity plan",
            content: `
            <p>
              You can see any doctor you choose. Typically, your dentist will file claims for you and then you will pay your portion based on your plan. 
            </p>
            <0>Consider this plan if:</0>
            <1>
              <0>
                You are concerned about the cost of maintaining your healthy smile 
              </0>
              <0>
                You have any upcoming procedures that will require multiple visits to the dentist.
              </0>
            </1>
            `,
            content_MULTI_CHOICE: `
              <p>
                You can see any doctor you choose. Typically, your dentist will file claims for you and then you will pay your portion based on your plan. 
              </p>
              <0>Consider this plan if:</0>
              <1>
                <0>
                  Your family is in more than one location and you need the flexibility to go to any dentist.
                </0>
                <0>
                  There are services not covered in the copay schedule that you will need.
                </0>
              </1>
              `,
          },
          LOW_HIGH: {
            subHeading: "Indemnity plan",
            content: `
              <p>
                You can see any doctor you choose. Typically, your dentist will file claims for you and then you will pay your portion based on your plan. 
              </p>
              <p>Your employer is offering you a choice of plans. Please review the plan summary for information about both plans and choose the one plan that best fits your needs.</p>
              <0>Consider this plan if:</0>
              <1>
                <0>
                  You are concerned about the cost of maintaining your healthy smile 
                </0>
                <0>
                  You have any upcoming procedures that will require multiple visits to the dentist.
                </0>
              </1>
              `,
            content_MULTI_CHOICE: `
              <p>
                You can see any doctor you choose. Typically, your dentist will file claims for you and then you will pay your portion based on your plan. 
              </p>
              <p>Your employer is offering you a choice of plans. Please review the plan summary for information about both plans and choose the one plan that best fits your needs.</p>
              <0>Consider this plan if:</0>
              <1>
                <0>
                  Your family is in more than one location and you need the flexibility to go to any dentist.
                </0>
                <0>
                  There are services not covered in the copay schedule that you will need.
                </0>
              </1>
              `,
          },
        },
      },
      DHMO: {
        default: {
          default: {
            DHMO: "Prepaid/DHMO Plan",
            DHMO_TX: "Prepaid Dentists",
            DHMO_FL: "Prepaid Dentists",
            subHeading: "{{localizedPlanName}}",
            content: `
            <p>
              This plan offers fixed copays so you know what you will pay out-of-pocket when you go to the dentist. You will need to choose a dentist within the network.
            </p>
            <0>Consider this plan if:</0>
            <1>
              <0>
                You are concerned about the cost of maintaining your healthy smile.
              </0>
              <0>
                You have any upcoming procedures that will require multiple visits to the dentist.
              </0>
            </1>
          `,
            content_MULTI_CHOICE: `
            <p>
              This plan offers fixed copays so you know what you will pay out-of-pocket when you go to the dentist. You will need to choose a dentist within the network.
            </p>
            <0>Consider this plan if:</0>
            <1>
              <0>
                You need a lot of dental work that might cause you to exceed the PPO maximum.
              </0>
              <0>
                You need dental work right away that would require you to wait if you had a PPO plan.
              </0>
            </1>
          `,
          },
        },
      },
    },
    VISION: {
      default: {
        default: {
          default: {
            subHeading: "",
            content: `
            <0>Consider this plan if:</0>
            <1>
              <0>You typically visit an eye care doctor during the course of a year.</0>
              <0>You would like discounts on glasses or contacts.</0>
            </1>
          `,
          },
        },
      },
    },
    ACCIDENT: {
      VAS: {
        sunLife: "<p>Benefits you can use now to protect what matters most to you.<sup>2</sup></p>",
        default: "",
      },
      VAS_1: {
        sunLife: `<0>Emergency Travel Assistance</0>
        <p>Help for emergencies that occur when you or a family member are travelling 100 or more miles from home. The help can be medical, dental, or legal.</p>
      
        <0>Identity Theft Protection</0>
        <p>Get 24-hour surveillance of up to 10 credit or debit cards. In addition, if someone compromises your data, you can get help from anti-fraud experts.</p>`,
        default: "",
      },
      default: {
        default: {
          default: {
            subHeading: "",
            content: `
            <0>Consider this plan if:</0>
            <1>
              <0>You have an active lifestyle such as playing sports or riding a bike to work.</0>
              <0>You have a high deductible with your health coverage.</0>
            </1>
          `,
          },
          LOW_HIGH: {
            subHeading: "",
            content: `
            <p>Your employer is offering you a choice of plans. Please review the plan summary information for information about both plans and choose the one plan that best fits your needs.</p>
            <0>Consider this plan if:</0>
            <1>
              <0>You have an active lifestyle such as playing sports or riding a bike to work.</0>
              <0>You have a high deductible with your health coverage.</0>
            </1>`,
          },
        },
      },
    },
    HOSPITAL_INDEMNITY: {
      default: {
        default: {
          default: {
            subHeading: "",
            content: `
            <0>Consider this plan if:</0>
            <1>
              <0>You are concerned about the likelihood of costly hospital stays.</0>
              <0>You have limited savings to pay for other expenses if you were sick or injured and needed to stay in the hospital.</0>
            </1>
          `,
          },
          LOW_HIGH: {
            subHeading: "",
            content: `
            <p>Your employer is offering you a choice of plans. Please review the information for both plans and choose the one plan that best fits your needs.</p>
            <0>Consider this plan if:</0>
            <1>
              <0>You are concerned about the likelihood of costly hospital stays.</0>
              <0>You have limited savings to pay for other expenses if you were sick or injured and needed to stay in the hospital.</0>
            </1>`,
          },
        },
      },
    },
    LIFE: {
      VAS: {
        sunLife: "<p>Benefits you can use now to protect what matters most to you.<sup>1</sup></p>",
        default: "",
      },
      VAS_1: {
        sunLife: `<0>Emergency Travel Assistance</0>
        <p>Help for emergencies that occur when you or a family member are travelling 100 or more miles from home. The help can be medical, dental, or legal.</p>
      
        <0>Identity Theft Protection</0>
        <p>Get 24-hour surveillance of up to 10 credit or debit cards. In addition, if someone compromises your data, you can get help from anti-fraud experts.</p>`,
        default: "",
      },
      VAS_2: {
        sunLife: `<0>Claimant Support</0> 
        <p>Take advantage of professional counselling and/or information from clinicians, attorneys, and other specialists.</p>
      
        <0>Online will preparation</0>
        <p>Create a will, name an executor, and designate a guardian(s) for your children.</p>`,
        default: "",
      },
      Self_Care_Plus: {
        sunLife: `<0>Self Care from AbleTo</0> 
        <p>Get mental health support with the use of digital tools like mindfulness activities, guided journals, blogs, and meditations.</p>`,
        default: "",
      },
      BASIC_LIFE: {
        default: {
          default: {
            subHeading: "",
            content: `<p>Your employer is providing you with coverage at no cost to you.</p>`,
          },
          BUY_UP: {
            subHeading: "",
            content: `
            <p>Your employer is funding a base plan for you, and you have the option to add more coverage.</p>
            <0>Consider this plan if:</0>
            <1>
              <0>You think you will need additional coverage beyond what your employer is funding. </0>
            </1>`,
          },
        },
      },
      VOLUNTARY_LIFE: {
        default: {
          default: {
            subHeading: "",
            content: `
            <0>Consider this plan if:</0>
            <1>
              <0>You have loved ones who rely on your income.</0>
              <0>You have any debts or future education costs.</0>
            </1>
          `,
          },
        },
      },
      STANDALONE_ADD: {
        default: {
          default: {
            subHeading: "",
            content: `
            <0>Consider this plan if:</0>
            <1>
              <0>You have loved ones who rely on your income.</0>
              <0>You have any debts or future education costs.</0>
            </1>
            `,
          },
        },
      },
    },
    CRITICAL_ILLNESS: {
      default: {
        default: {
          default: {
            subHeading: "",
            content: `
            <0>Consider this plan if:</0>
            <1>
              <0>You have a family history of heart attack, stroke, or another condition included in the plan.</0>
              <0>You have limited savings to pay for expenses if you have a serious illness.</0>
            </1>
          `,
          },
        },
      },
    },
    CANCER: {
      default: {
        default: {
          default: {
            subHeading: "",
            content: `
            <0>Consider this plan if:</0>
            <1>
              <0>You have a family history of cancer or receive regular cancer screenings</0>
              <0>You have limited savings to cover expenses if you are diagnosed with and receive treatment for cancer. </0>
            </1>
          `,
          },
          LEVEL_1_LEVEL_2: {
            subHeading: "",
            content: `
            <p>Your employer is offering you a choice of plans. Please review the information for both plans and choose the one plan that best fits your needs.</p>
            <0>Consider this plan if:</0>
            <1>
              <0>You have a family history of cancer or receive regular cancer screenings</0>
              <0>You have limited savings to cover expenses if you are diagnosed with and receive treatment for cancer. </0>
            </1>`,
          },
        },
      },
    },
    FINANCIAL: {
      HSA: {
        default: {
          default: {
            subHeading: "",
            content: `
              <p>
                An HSA is a savings account to help you pay for out-of-pocket medical, dental and vision expenses. This account is available only if you enroll in a High Deductible Health Plan (HDHP).  
                <br />
                <br />
                You and your employer may contribute funds to this account up to a yearly maximum. You can use these funds to pay for deductibles, copays, coinsurance and other medical expenses. The money in your HSA belongs to you and accumulates each year. 
              </p>
              <0>Why you might choose this:</0>
              <1>
                <0>
                  Save funds pre-tax for short- or long-term health care expenses.  
                </0>
                <0>
                  You can keep the money you save even if you leave your employer.  
                </0>
                <0>
                  The money you don’t use rolls over for use in future years.
                </0>
              </1>
            `,
          },
        },
      },
      FSA: {
        default: {
          default: {
            subHeading: "",
            content: `
              <p>
                This is an arrangement with your employer where they set up an account for you to save pre-tax dollars for medical, dental and vision expenses.  
                <br />
                <br />
                You and your employer may contribute funds up to a yearly maximum. If you leave your job or don’t use the money by a certain time, you forfeit the money. 
              </p>
              <0>Why you might choose this:</0>
              <1>
                <0>
                  Save funds pre-tax to pay for health care expenses which you expect to pay during the year.
                </0>
              </1>
            `,
          },
        },
      },
      LPFSA: {
        default: {
          default: {
            subHeading: "",
            content: `
              <p>
                This is an account that you can fund with pre-tax dollars to pay dental and vision expenses. Some employers allow you to enroll in both an HSA and an LPFSA.  
                <br /> 
                <br />
                There is an annual maximum for contributions. You may not be able to roll over money each year so be careful how much you contribute. 
              </p>
              <0>Why you might choose this:</0>
              <1>
                <0>
                  Save funds pre-tax for dental and vision expenses which you expect to pay during the year. 
                </0>
              </1>
            `,
          },
        },
      },
      DCA: {
        default: {
          default: {
            subHeading: "",
            content: `
              <p>
                These accounts allow you to pay for qualified child and dependent care expenses with pre-tax dollars. You choose the amount that is deposited from each paycheck up to an annual maximum. After you have paid for certain expenses, you can apply for a reimbursement from your account. If you do not use the money by a certain time, you forfeit the money.
              </p>
              <0>Why you might choose this:</0>
              <1>
                <0>
                Save funds pre-tax to pay for dependent care expenses during the year.
                </0>
              </1>
            `,
          },
        },
      },
      HRA: {
        default: {
          default: {
            subHeading: "",
            content: `
              <p>
              This is an employer-funded arrangement that reimburses you for qualified medical expenses. If you leave your job, you will forfeit the money.
              </p>
              <0>Why you might choose this:</0>
              <1>
                <0>
                  Your employer is giving you money to use towards your health care expenses.
                </0>
              </1>
            `,
          },
        },
      },
    },
    SHORT_TERM_DISABILITY: {
      EMPLOYER_PAID: {
        default: {
          default: {
            subHeading: "",
            content: `
              <p>Your employer is providing you with coverage at no cost to you.</p>
            `,
          },
          BUY_UP: {
            subHeading: "",
            content: `
              <p>Your employer is funding a base plan for you, and you have the option to add more coverage.</p>
              <0>Consider this plan if:</0>
              <1>
                <0>You think you’ll need additional disability coverage beyond what your employer is funding.</0>
              </1>
            `,
          },
        },
      },
      VOLUNTARY: {
        default: {
          BUY_UP: {
            subHeading: "",
            content: `
              <0>Consider this plan if:</0>
              <1>
                <0>You don’t have enough savings to cover expenses while you are out of work.</0>
                <0>You have a family history of medical issues, like cancer, that could cause you to miss work. </0>
              </1>
            `,
          },
          default: {
            subHeading: "",
            content: `
              <0>Consider this plan if:</0>
              <1>
                <0>You don’t have enough savings to cover expenses while you are out of work.</0>
                <0>You have a family history of medical issues, like cancer, that could cause you to miss work. </0>
              </1>
            `,
          },
        },
      },
    },
    LONG_TERM_DISABILITY: {
      EMPLOYER_PAID: {
        default: {
          default: {
            subHeading: "",
            content: `
              <p>Your employer is providing you with coverage at no cost to you.</p>
            `,
          },
          BUY_UP: {
            subHeading: "",
            content: `
              <p>Your employer is funding a base plan for you, and you have the option to add more coverage.</p>
              <0>Consider this plan if:</0>
              <1>
                <0>You think you’ll need additional disability coverage beyond what your employer is funding.</0>
              </1>
            `,
          },
        },
      },
      VOLUNTARY: {
        default: {
          BUY_UP: {
            subHeading: "",
            content: `
              <0>Consider this plan if:</0>
              <1>
                <0>You don’t have enough savings to cover an extended period out of work.</0>
                <0>You have a family history of medical issues, like cancer, that could cause you to miss work.</0>
              </1>
            `,
          },
          default: {
            subHeading: "",
            content: `
              <0>Consider this plan if:</0>
              <1>
                <0>You don’t have enough savings to cover an extended period out of work.</0>
                <0>You have a family history of medical issues, like cancer, that could cause you to miss work.</0>
              </1>
            `,
          },
        },
      },
    },
    GAP: {
      default: {
        default: {
          default: {
            subHeading: "",
            content: `
            <0>Some things to consider:</0>
            <1>
              <0>You must be enrolled in your employer’s major medical plan.</0>
              <0>This plan is not compatible with a health savings account (HSA).</0>
              <0>It pays in addition to any other coverages.</0>
            </1>
          `,
          },
        },
      },
    },
    OTHER: {},
  },
  ExplorerBenefitFindDoctor: {
    VISION: {
      header: "Finding an eye care doctor",
      description: "With an in-network doctor you’ll get more and save more!",
      callToAction: "Find an eye care doctor",
    },
    DENTAL: {
      header: "Finding a dentist",
      description:
        "Check out our network to find a dentist near you. If you can’t find the dentist you want, you can <0>nominate your dentist</0> to be included in our network.",
      callToAction_one: "Find a dentist",
      callToAction_other: "Find a {{planType}} dentist",
      callToAction_DHMO_TX_other: "Find a prepaid dentist",
      callToAction_DHMO_FL_other: "Find a prepaid dentist",
    },
  },
  ExplorerBenefitRealWorld: {
    header: "Real-world example of how it works",
    ACCIDENT: {
      title: "Rosa broke her leg while hiking in the mountains",
      subTitle:
        "She used her health insurance to get emergency care at a hospital and physical therapy as she recovered. Her high deductible meant she would be paying at least $2,500.",
      bulletListHeader: "USED HER PLAN TO:",
      bulletList: [
        "Replenish her savings account",
        "Pay for physical therapy",
        "Buy a new, sturdy pair of hiking boots",
      ],
      description:
        "As Rosa was getting better, she filed a claim for the injury and treatments. She received a cash benefit for each approved injury, treatment, and service.",
      costsHeader: "Her costs",
      costs: [
        {
          name: "Medical expenses",
          amount: "$5,700",
        },
        {
          name: "Rosa’s deductible",
          amount: "-$2,500",
        },
        {
          name: "Rosa’s bills after deductible",
          amount: "-$640",
        },
        {
          name: "Health insurance plan paid",
          amount: "-$2,560",
        },
      ],
      costTotal: "$3,140",
      costTotalSubTitle: "Rosa’s out-of-pocket costs",
      showClaims: true,
      claimsHeader: "The claims",
      claims: [
        {
          name: "Ambulance ride",
          amount: "$400",
        },
        {
          name: "Emergency room visit",
          amount: "$200",
        },
        {
          name: "X-ray",
          amount: "$100",
        },
        {
          name: "Leg fracture",
          amount: "$2,000",
        },
        {
          name: "Physical therapy (6 visits)",
          amount: "$300",
        },
        {
          name: "Medical device (crutches)",
          amount: "$500",
        },
      ],
      claimsTotal: "$3,500",
      claimsTotalSubTitle: "Rosa’s payment from {{carrier}}",
      disclaimer:
        "This is an example for illustrative purposes only. Actual costs and benefits may vary based on the terms of the policy and the specific circumstances. See plan documents for specific coverage amounts, details, limitations, and exclusions.",
    },
    CANCER: {
      title: "Jane’s recovery from breast cancer",
      subTitle:
        "Jane found out she had breast cancer in her mid-40s. Fortunately, she had health insurance to help with screenings and treatments. Her health insurance has a high deductible and she still has coinsurance.",
      bulletListHeader: "USED HER PLAN TO:",
      bulletList: [
        "Help cover out-of-pocket medical expenses",
        "Pay for travel expenses to appointments",
        "Housekeeping and takeout to ease her workload",
      ],
      description:
        "During treatment, Jane filed claims for the first cancer screening, the treatments, and the medicines she received. She filed three separate claims and can continue to file claims as she receives covered treatments and services.",
      costsHeader: "Her costs",
      costs: [
        {
          name: "Medical expenses",
          amount: "$48,000",
        },
        {
          name: "Jane's deductible",
          amount: "-$2,500",
        },
        {
          name: "Jane's bills after deductible",
          amount: "-$4,550",
        },
        {
          name: "Health insurance plan paid",
          amount: "-$40,950",
        },
      ],
      costTotal: "$7,050",
      costTotalSubTitle: "Jane’s out-of-pocket costs",
      showClaims: true,
      claimsHeader: "The claims",
      claims: [
        {
          name: "Cancer screening",
          amount: "$50",
        },
        {
          name: "Second surgical opinion",
          amount: "$200",
        },
        {
          name: "Needle biopsy and general anesthesia",
          amount: "$200",
        },
        {
          name: "Lumpectomy and general anesthesia",
          amount: "$400",
        },
        {
          name: "External radiation therapy (6 weeks)",
          amount: "$2,400",
        },
        {
          name: "Chemotherapy (6 months)",
          amount: "$4,000",
        },
      ],
      claimsTotal: "$7,250",
      claimsTotalSubTitle: "Jane's payment from {{carrier}}",
      disclaimer:
        "This is an example for illustrative purposes only. Actual costs and benefits may vary based on the terms of the policy and the specific circumstances. See plan documents for specific coverage amounts, details, limitations, and exclusions.",
    },
    HOSPITAL_INDEMNITY: {
      title:
        "Sandra caught pneumonia. She had to stay in the ICU for 3 days followed by 9 days in a regular room.",
      subTitle:
        "Sandra's health insurance covered the services and treatments at 90%, but she still had out-of-pocket costs for her share.",
      bulletListHeader: "USED HER PLAN FOR:",
      bulletList: [
        "Hospital copays",
        "Restocking her groceries",
        "Hotel and transportation costs for her family",
      ],
      description:
        "After she came home from the hospital, Sandra filed a claim. She received a lump sum payment based on her days in the hospital and the ICU.",
      costsHeader: "Her costs",
      costs: [
        {
          name: "Medical expenses",
          amount: "$23,594",
        },
        {
          name: "Sandra's deductible",
          amount: "-$2,500",
        },
        {
          name: "Sandra's bills after deductible",
          amount: "-$2,109",
        },
        {
          name: "Health insurance plan paid",
          amount: "-$18,985",
        },
      ],
      costTotal: "$4,609",
      costTotalSubTitle: "Sandra's out-of-pocket costs",
      showClaims: true,
      claimsHeader: "The claims",
      claims: [
        {
          name: "First day hospital confinement",
          amount: "$1,000",
        },
        {
          name: "Additional hospital confinement (12 days total)",
          amount: "$1,200",
        },
        {
          name: "ICU confinement (3 days in ICU)",
          amount: "$300",
        },
        {
          name: "Extended hospitalization (12 days) ",
          amount: "$1,200",
        },
      ],
      claimsTotal: "$3,700",
      claimsTotalSubTitle: "Sandra's payment from {{carrier}}",
      disclaimer:
        "This is an example for illustrative purposes only. Actual costs and benefits may vary based on the terms of the policy and the specific circumstances. See plan documents for specific coverage amounts, details, limitations, and exclusions.",
    },
    CRITICAL_ILLNESS: {
      title: "Len’s recovery from a heart attack",
      subTitle:
        "Len suffered a heart attack due to a blocked artery. He was fortunate that his health insurance helped cover his ambulance and the care he received at the hospital. While Len was recovering, he had other expenses outside of what his health insurance would pay for though.",
      bulletListHeader: "USED HIS PLAN TO:",
      bulletList: [
        "Pay his portion of the hospital bills",
        "Supplement his reduced income while he couldn't work",
        "Start a new diet to focus on his health",
      ],
      description:
        "After he came home from the hospital, Len filed his claim. He received a lump sum payment based on his heart attack diagnosis and the benefit amount he chose.",
      costsHeader: "His costs",
      costs: [
        {
          name: "Medical expenses",
          amount: "$24,520",
        },
        {
          name: "Len's deductible",
          amount: "-$2,500",
        },
        {
          name: "Len's bills after deductible",
          amount: "-$4,404",
        },
        {
          name: "Health insurance plan paid",
          amount: "-$17,616",
        },
      ],
      costTotal: "$6,904",
      costTotalSubTitle: "Len's out-of-pocket costs",
      showClaims: true,
      claimsHeader: "The claims",
      claims: [
        {
          name: "Heart Attack",
          amount: "$15,000",
        },
      ],
      claimsTotal: "$15,000",
      claimsTotalSubTitle: "Len's payment",
      disclaimer:
        "This is an example for illustrative purposes only. Actual costs and benefits may vary based on the terms of the policy and the specific circumstances. See plan documents for specific coverage amounts, details, limitations, and exclusions.",
    },
    GAP: {
      title: "Lakisha had a heart attack.",
      subTitle:
        "Luckily, she has a $2,000 inpatient / $1,000 outpatient gap plan to help with out-of-pocket expenses. Her medical plan has a $1,500 deductible, 80/20 coinsurance and $2,500 out-of-pocket maximum.",
      bulletListHeader: "USED HER PLAN TO:",
      bulletList: ["Pay her deductible", "Pay her coinsurance"],
      description:
        "While getting better, Lakisha filed a claim with a copy of her bill. She was able to get help with her out-of-pocket expenses.",
      costsHeader: "Her costs with gap coverage",
      costs: [
        {
          name: "Medical expenses (hospital & surgery)",
          amount: "$12,000",
        },
        {
          name: "Medical plan deductible",
          amount: "-$1,500",
        },
        {
          name: "Medical plan coinsurance",
          amount: "-$1,000",
        },
        {
          name: "Total medical plan out-of-pocket",
          amount: "$2,500",
        },
        {
          name: "Selected gap Benefit",
          amount: "$2,000",
        },
      ],
      costTotal: "$500",
      costTotalSubTitle: "Lakisha’s out-of-pocket costs",
      showClaims: true,
      claimsHeader: "Her costs without gap coverage",
      claims: [
        {
          name: "Medical expenses (hospital & surgery)",
          amount: "$12,000",
        },
        {
          name: "Medical plan deductible",
          amount: "-$1,500",
        },
        {
          name: "Medical plan coinsurance",
          amount: "-$1,000",
        },
        {
          name: "Total medical plan out-of-pocket",
          amount: "$2,500",
        },
        {
          name: "Selected gap Benefit",
          amount: "$0",
        },
      ],
      claimsTotal: "$2,500",
      claimsTotalSubTitle: "Lakisha’s out of pocket costs",
      disclaimer:
        "This is an example for illustrative purposes only. Actual costs and benefits may vary based on the terms of the policy and the specific circumstances. See plan documents for specific coverage amounts, details, limitations, and exclusions.",
    },
    LONG_TERM_DISABILITY: {
      title: "Meet Steve. He found out he had cancer about a year ago.",
      subTitle:
        "His treatments and recovery had him out of the office for over nine months. How did LTD insurance help Steve while he was unable to work?",
      bulletListHeader: "USED HIS PLAN TO:",
      bulletList: ["Pay for mortgage payments", "Pay for childcare and groceries"],
      description: "He can use this money for anything, no strings attached.",
      costsHeader: "His payout",
      costs: [
        {
          name: "Steve's annual salary",
          amount: "$50,000",
        },
        {
          name: "Benefit amount",
          amount: "{{benefitAmountAndHelpTextCopy}}",
        },
        {
          name: "Monthly LTD benefit<sup>2</sup>",
          amount: "{{monthlyBenefitCopy}}",
        },
      ],
      costTotal: "{{payoutCopy}}",
      costTotalSubTitle: "Steve's payout",
      showClaims: false,
      disclaimer:
        "The payouts in this illustrative example are for a {{benefitAmountAndHelpTextCopy}} LTD plan. For the specific details of your plan, consult the plan summary or your benefits administrator.",
    },
    SHORT_TERM_DISABILITY: {
      title:
        "Meet Maria. She had a baby this past year and needed to go on bed rest before the birth. She was unable to work for two months.",
      subTitle: "How did STD insurance help Maria while she was unable to work?",
      bulletListHeader: "USED HER PLAN TO:",
      bulletList: ["Pay for mortgage payments", "Pay for childcare and groceries"],
      description:
        "Maria can use this money for anything, no strings attached. The extra cash in her pocket helped with her mortgage, bills, and groceries.",
      costsHeader: "Her payout",
      costs: [
        {
          name: "Annual salary",
          amount: "$50,000",
        },
        {
          name: "Benefit amount",
          amount: "{{benefitAmountAndHelpTextCopy}}",
        },
        {
          name: "Weekly STD benefit<sup>3</sup>",
          amount: "{{monthlyBenefitCopy}}",
        },
      ],
      costTotal: "{{payoutCopy}}/week",
      costTotalSubTitle: "Maria's payout while on bed rest",
      showClaims: false,
      disclaimer:
        "The payouts in this illustrative example are for a {{benefitAmountAndHelpTextCopy}} STD plan. For the specific details of your plan, consult the plan summary or your benefits administrator.",
    },
  },
  ExplorerPlanComparisonTable: {
    NotApplicable: "N/A",
    Frequency: {
      Yearly: "Once every 12 months",
      BiYearly: "Once every 24 months",
    },
    MEDICAL: {
      // Legacy plan table.
      default: {
        heading: "Plan comparison",
        tableHeaders: [
          "",
          "Plan type",
          "Premium costs",
          "Deductible/Out-of-pocket costs",
          "Health Savings Account compatible",
          "In-Network benefits",
          "Out-of-Network benefits",
          "Requires choosing a Primary Care Provider (PCP) to coordinate your care",
          "Specialty care requires a referral from your Primary Care Provider (PCP)",
        ],
        HMO: [
          "{{planName}}",
          "HMO",
          "{{premium}}",
          "{{outOfPocketCosts}}",
          "{{HSA}}",
          "Yes",
          "No, unless emergency",
          "Yes",
          "Yes",
        ],
        HMO_HDHP: [
          "{{planName}}",
          "HMO HDHP",
          "{{premium}}",
          "{{outOfPocketCosts}}",
          "{{HSA}}",
          "Yes",
          "No, unless emergency",
          "Yes",
          "Yes",
        ],
        PPO: [
          "{{planName}}",
          "PPO",
          "{{premium}}",
          "{{outOfPocketCosts}}",
          "{{HSA}}",
          "Yes",
          "Yes, but at a higher cost",
          "No",
          "No",
        ],
        PPO_HDHP: [
          "{{planName}}",
          "PPO HDHP",
          "{{premium}}",
          "{{outOfPocketCosts}}",
          "{{HSA}}",
          "Yes",
          "Yes, but at a higher cost",
          "No",
          "No",
        ],
        POS: [
          "{{planName}}",
          "POS",
          "{{premium}}",
          "{{outOfPocketCosts}}",
          "{{HSA}}",
          "Yes",
          "Yes, but at a higher cost",
          "Yes",
          "Yes",
        ],
        POS_HDHP: [
          "{{planName}}",
          "POS HDHP",
          "{{premium}}",
          "{{outOfPocketCosts}}",
          "{{HSA}}",
          "Yes",
          "Yes, but at a higher cost",
          "Yes",
          "Yes",
        ],
        EPO: [
          "{{planName}}",
          "EPO",
          "{{premium}}",
          "{{outOfPocketCosts}}",
          "{{HSA}}",
          "Yes",
          "No, unless emergency",
          "Often, but not always",
          "May or may not",
        ],
        EPO_HDHP: [
          "{{planName}}",
          "EPO HDHP",
          "{{premium}}",
          "{{outOfPocketCosts}}",
          "{{HSA}}",
          "Yes",
          "No, unless emergency",
          "Often, but not always",
          "May or may not",
        ],
        OAP: [
          "{{planName}}",
          "OAP",
          "{{premium}}",
          "{{outOfPocketCosts}}",
          "{{HSA}}",
          "Yes",
          "Yes, but at a higher cost",
          "No",
          "No",
        ],
        OAP_HDHP: [
          "{{planName}}",
          "OAP HDHP",
          "{{premium}}",
          "{{outOfPocketCosts}}",
          "{{HSA}}",
          "Yes",
          "Yes, but at a higher cost",
          "No",
          "No",
        ],
        MEC: [
          "{{planName}}",
          "MEC",
          "{{premium}}",
          "{{outOfPocketCosts}}",
          "{{HSA}}",
          "No",
          "Yes, but at a higher cost",
          "No",
          "No",
        ],
        MEC_HDHP: [
          "{{planName}}",
          "MEC HDHP",
          "{{premium}}",
          "{{outOfPocketCosts}}",
          "{{HSA}}",
          "No",
          "Yes, but at a higher cost",
          "No",
          "No",
        ],
        planSummaryHeader: "Link to plan summary",
        planSummaryCell: "{{planName}} plan summary",
        planMessage: `<2>Medical plans are complex and this table simplifies things a bit, for all the details please download and review the summary for each plan.</2>
          <2>The plan summary will cover things like what counts toward your deductible, if you have co-pays, and other important details.</2>`,
        planMessageSupplemental: {
          top: `<2>In addition to medical benefits you also have more benefits to review to supplement your coverage.</2>`,
          bottom: `<2>You can explore the cost of different plans by beginning your enrollment when you are ready.</2>`,
        },
      },
      custom: {
        tableHeaders: {
          planName: "<0>Plan name</0>",
          carrier: "<0>Carrier</0>",
          planType: "<0>Plan type</0>",
          individualDeductible: "<0>Individual deductible</0><1>(in-network / out-of-network)</1>",
          individualDeductibleOutOfNetworkNA: "<0>Individual deductible</0>",
          familyDeductible: "<0>Family deductible</0><1>(in-network / out-of-network)</1>",
          familyDeductibleOutOfNetworkNA: "<0>Family deductible</0>",
          individualOutOfPocketMaximum:
            "<0>Individual out of pocket maximum</0><1>(in-network / out-of-network)</1>",
          individualOutOfPocketMaximumOutOfNetworkNA: "<0>Individual out of pocket maximum</0>",
          familyOutOfPocketMaximum:
            "<0>Family out of pocket maximum</0><1>(in-network / out-of-network)</1>",
          familyOutOfPocketMaximumOutOfNetworkNA: "<0>Family out of pocket maximum</0>",
          hsaCompatible: "<0>Health Savings Account Compatible</0>",
          employerHsaContribution: "<0>Employer contributions to Health Savings Account</0>",
          outOfNetworkBenefits: "<0>Out-of-Network benefits</0>",
          requiresPcp:
            "<0>Requires choosing a Primary Care Provider (PCP) to coordinate your care</0>",
          specialtyCareReferral:
            "<0>Specialty care requires a referral from your Primary Care Provider (PCP)</0>",
          linkToFullPlanSummary: "<0>Link to full plan summary</0>",
        },
        tableCells: {
          na: "N/A",
          outOfNetworkBenefits: {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- these are constants
            [String(medicalOutOfNetworkBenefits.yes!.value)]: "Yes, but at a higher cost",
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- these are constants
            [String(medicalOutOfNetworkBenefits.no!.value)]: "No, unless emergency",
          },
          requiresPcp: {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- these are constants
            [String(medicalRequiresPcp.yes!.value)]: "Yes",
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- these are constants
            [String(medicalRequiresPcp.no!.value)]: "No",
          },
          specialtyCareReferral: {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- these are constants
            [String(medicalSpecialtyCareReferral.yes!.value)]: "Yes",
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- these are constants
            [String(medicalSpecialtyCareReferral.no!.value)]: "No",
          },
          downloadPlanSummary: "{{planName}} summary",
        },
        tableFooters: {
          default:
            "<0>Medical plans are complex and this table simplifies things a bit, for all the details please download and review the summary for each plan.<br>The plan summary will cover things like what counts toward your deductible, if you have co-pays, and other important details.</0><1></1><2>You can explore the cost of different plans by beginning your enrollment when you are ready.</2>",
          supplementalBenefits:
            "In addition to medical benefits you also have more benefits to review to supplement your coverage.",
        },
      },
    },
    DENTAL: {
      PPO: {
        heading: "Let’s look at how a dental plan could help",
        tableHeaders: [
          "Services",
          "Adult cleaning (2 per year)",
          "Oral examination (2 per year)",
          "Bitewing x-rays",
          "Filling",
          "Annual Premium<sup>3</sup>",
          "Total",
        ],
        PPO: ["Dental plan", "$0", "$0", "$0", "$73 coinsurance<sup>2</sup>", "$230", "$303"],
        ASO_PPO: ["Dental plan", "$0", "$0", "$0", "$73 coinsurance<sup>2</sup>", "$230", "$303"],
        INDEMNITY: ["Dental plan", "$0", "$0", "$0", "$73 coinsurance<sup>2</sup>", "$230", "$303"],
        NONE: ["No plan<sup>1</sup>", "$220", "$126", "$75", "$263", "$0", "$684"],
        planMessage: `
          <0>Having a dental plan could save you up to $381.</0>
          <1>
            With a long list of covered treatments, a dental plan is likely to help with any financial burden.
          </1>
          <2>
            The payouts in this illustrative example are for a generic dental plan. For the specific details of your plan, consult the plan summary or your benefits administrator.
          </2>
        `,
      },
      DHMO: {
        heading: "Let’s look at how a dental plan could help",
        tableHeaders: [
          "Services",
          "Adult cleaning (2 per year)",
          "Oral examination (2 per year)",
          "Bitewing x-rays",
          "Filling",
          "Annual fee<sup>2</sup>",
          "Total",
        ],
        NONE: ["No plan<sup>1</sup>", "$220", "$126", "$75", "$263", "$0", "$684"],
        DHMO: ["Dental plan", "$10 copay", "$0", "$0", "$80 copay", "$144", "$234"],
        planMessage: `
          <0>Having a dental plan could save you up to $381.</0>
          <1>
            With a long list of covered treatments, a dental plan is likely to help with any
            financial burden.
          </1>
          <2>
            The payouts in this illustrative example are for a generic dental plan. For the specific details of your plan, consult the plan summary or your benefits administrator.
          </2>
        `,
      },
      MULTI_CHOICE: {
        heading: "Let’s look at how a dental plan could help",
        tableHeaders: [
          "Services",
          "Adult cleaning (2 per year)",
          "Oral examination (2 per year)",
          "Bitewing x-rays",
          "Filling",
          "Annual fee<sup>3</sup>",
          "Total",
        ],
        PPO: ["PPO plan", "$0", "$0", "$0", "$73 coinsurance<sup>2</sup>", "$230", "$303"],
        DHMO: ["Prepaid/DHMO plan", "$10 copay", "$0", "$0", "$80 copay", "$144", "$234"],
        DHMO_TX: ["Prepaid plan", "$10 copay", "$0", "$0", "$80 copay", "$144", "$234"],
        DHMO_FL: ["Prepaid plan", "$10 copay", "$0", "$0", "$80 copay", "$144", "$234"],
        NONE: ["No plan<sup>1</sup>", "$220", "$126", "$75", "$263", "$0", "$684"],
        planMessage: `
          <0>Having a dental plan could save you up to $381.</0>
          <1>
            With a long list of covered treatments, a dental plan is likely to help with any
            financial burden.
          </1>
          <2>
            The payouts in this illustrative example are for a generic dental plan. For the specific details of your plan, consult the plan summary or your benefits administrator.
          </2>
        `,
      },
      default: {
        heading: "Let’s look at how a dental plan could help",
        tableHeaders: [
          "Services",
          "Adult cleaning (2 per year)",
          "Oral examination (2 per year)",
          "Bitewing x-rays",
          "Filling",
          "Annual Premium<sup>3</sup>",
          "Total",
        ],
        PPO: ["PPO plan", "$0", "$0", "$0", "$73 coinsurance<sup>2</sup>", "$230", "$303"],
        DHMO: ["Prepaid/DHMO plan", "$10", "$0", "$0", "$80 copay", "$144", "$234"],
        NONE: ["No plan<sup>1</sup>", "$220", "$126", "$75", "$263", "$0", "$684"],
        planMessage: `
          <0>Having a dental plan could save you up to $381.</0>
          <1>
            With a long list of covered treatments, a dental plan is likely to help with any
            financial burden.
          </1>
          <2>
            The payouts in this illustrative example are for a generic dental plan. For the specific details of your plan, consult the plan summary or your benefits administrator.
          </2>
        `,
      },
      custom: {
        tableHeaders: {
          planName: "<0>Plan name</0>",
          carrier: "<0>Carrier</0>",
          planType: "<0>Plan type</0>",
          individualPlanYearDeductible:
            "<0>Individual plan year deductible</0><1>(in-network / out-of-network)</1>",
          individualCalendarYearDeductible:
            "<0>Individual calendar year deductible</0><1>(in-network / out-of-network)</1>",
          individualPlanYearDeductibleNA: "<0>Individual plan year deductible</0>",
          individualCalendarYearDeductibleNA: "<0>Individual calendar year deductible</0>",
          familyPlanYearDeductible:
            "<0>Family plan year deductible</0><1>(in-network / out-of-network)</1>",
          familyCalendarYearDeductible:
            "<0>Family calendar year deductible</0><1>(in-network / out-of-network)</1>",
          familyPlanYearDeductibleNA: "<0>Family plan year deductible<0>",
          familyCalendarYearDeductibleNA: "<0>Family calendar year deductible</0>",
          planYearMaximum:
            "<0>Plan year maximum</0><1>(in-network / out-of-network per person)</1>",
          calendarYearMaximum:
            "<0>Calendar year maximum</0><1>(in-network / out-of-network per person)</1>",
          planYearMaximumNA: "<0>Plan year maximum</0>",
          calendarYearMaximumNA: "<0>Calendar year maximum</0>",
          orthodonticServices: "<0>Ortho services</0>",
          lifetimeOrthodonticMaximum:
            "<0>Lifetime orthodontic maximum</0><1>(adults / children)</1>",
          type1Care:
            "<0>Type I preventive services like cleanings and exams</0><1>(in-network / out-of-network)</1>",
          type2Care:
            "<0>Type II basic services like fillings</0><1>(in-network / out-of-network)</1>",
          type3Care:
            "<0>Type III major services like surgeries</0><1>(in-network / out-of-network)</1>",
          linkToFullPlanSummary: "<0>Link to full plan summary</0>",
        },
        tableCells: {
          orthodonticServices: {
            [OrthodonticServicesValue.None]: "<0>No services offered</0>",
            [OrthodonticServicesValue.Children]:
              "<0>Children only</0><1>Covers 30% of costs up to the ortho maximum</1>",
            [OrthodonticServicesValue.Adults]:
              "<0>Adults only</0><1>Covers 50% of costs up to the ortho maximum</1>",
            [OrthodonticServicesValue.Both]:
              "<0>Both adults and children</0><1>Covers 50% of costs for adults and 30% of costs for children up to the ortho maximum</1>",
          },
          downloadPlanSummary: "{{planName}} summary",
          dhmo: `
            <0>DHMO plans have a different structure with co-pays.</0>
            <1 label='View the plan summary for full details.'></1>
            <2>You will need to make sure that you select a dentist within the network to use this plan.</2>
          `,
        },
        tableFooters: {
          default: `
            <0>
              You can explore the cost of different plans by beginning your enrollment when you are ready
            </0>
            <1>
              Dental plans can vary in the services and coverages that they provide. For all details, please download and review the summary for each plan.
            </1>
            <2>
              The plan summary will cover things like what counts toward your deductible, if you have co-pays, and other important details.
            </2>
          `,
        },
      },
    },
    VISION: {
      default: {
        heading: "Let’s look at how a vision plan could help",
        tableHeaders: [
          "Services",
          "Eye exam",
          "Frames",
          "Lens (Bifocal)",
          "Premium Progressive Lenses (e.g. Varilus physio)",
          "Total",
        ],
        default: [
          "With insurance<sup>1</sup>",
          "$10 copay",
          "$20 copay",
          "$20 copay",
          "$105",
          "$135",
        ],
        NONE: ["Without insurance<sup>2</sup>", "$205", "$130", "$171", "$173", "$679"],
        planMessage: `
          <0>A plan like this could save you up to $544</0>
          <1>
            With a long list of covered treatments, vision insurance is likely to help with any financial burden.
          </1>
          <2>
            The payouts in this illustrative example are for a generic vision plan. For the specific details of your plan, consult the plan summary or your benefits administrator. 
          </2>
        `,
      },
      custom: {
        tableHeaders: {
          planName: "<0>Plan name</0>",
          plan: "<0>{{plan}}</0>",
          carrier: "<0>Carrier</0>",
          examServices: "<0>Exam services</0>",
          lensAllowance: "<0>Lens allowance</0>",
          framesAllowance: "<0>Frames allowance</0>",
          framesOverAllowance: "<0>Additional discount for frames over allowance</0>",
          contactLensExam: "<0>Contact lens exam</0>",
          contactLensAllowance: "<0>Contact lens allowance</0>",
          linkToFullPlanSummary: "<0>Link to full plan summary</0>",
        },
        tableCells: {
          copay:
            "<0>{{min}} copay in-network</0><1>(Out-of-network will reimburse up to {{max}} instead)</1><2>*Once every {{frequency}} months.</2>",
          off: "<0>{{min}} off in-network</0><1>(Out-of-network gives up to {{max}} off instead)</1><2>*Once every {{frequency}} months.</2>",
          discount:
            "<0>{{min}} discount in-network</0><1>(Out-of-network gives {{max}} discount instead)</1><2>*Once every {{frequency}} months.</2>",
          downloadPlanSummary: "{{planName}} summary",
        },
        tableFooters: {
          default:
            "<0>This is only an overview of your vision plan, there are more details, especially about out-of-network costs. Please download and review the summary.</0><1>You can explore the cost of this plan by beginning your enrollment when you are ready.</1>",
        },
      },
    },
    FINANCIAL: {
      default: {
        heading: "Plan comparison",
        tableHeaders: [
          "",
          "What expenses are eligible?",
          "Am I eligible for it?",
          "Who contributes to it?",
          "Who technically owns the account?",
          "When are funds available?",
          "Does unused money rollover to next year?",
          "Can I take unused funds to my next employer?",
        ],
        HSA: [
          "HSA",
          "Medical, dental and vision expenses",
          "If you choose a qualified high deductible  health plan (HDHP)",
          "You, and possibly your employer",
          "You",
          "You can use only the balance of funds accrued in the account",
          "Yes. It’s yours until you use it",
          "Yes, the money is yours",
        ],
        HSA_HDHP: [
          "HSA",
          "Medical, dental and vision expenses",
          "If you choose {{linkedHDHPPlanName}}",
          "You, and possibly your employer",
          "You",
          "You can use only the balance of funds accrued in the account",
          "Yes. It’s yours until you use it",
          "Yes, the money is yours",
        ],
        FSA: [
          "FSA",
          "Medical, dental and vision expenses",
          "If it is offered then you are eligible",
          "You, and possibly your employer",
          "Your employer",
          "Your annual election is available on day one of your plan year",
          "No, it doesn’t rollover",
          "No",
        ],
        FSA_ROLLOVER: [
          "FSA",
          "Medical, dental and vision expenses",
          "If it is offered then you are eligible",
          "You, and possibly your employer",
          "Your employer",
          "Your annual election is available on day one of your plan year",
          "Yes, up to {{financialFSAMoneyRolloverAmount}} by {{financialFSAMoneyRolloverDate}}",
          "No",
        ],
        LPFSA: [
          "LPFSA",
          "Dental and vision expenses",
          "If you did not enroll in an FSA",
          "You, and possibly your employer",
          "Your employer",
          "Your annual election is available on day one of your plan year",
          "You lose it, with a few exceptions",
          "No",
        ],
        DCA: [
          "DCFSA",
          "Dependent care expenses",
          "If it is offered then you are eligible",
          "You, and possibly your employer",
          "Your employer",
          "You can use only the balance of funds accrued in the account",
          "No, it doesn’t rollover",
          "No",
        ],
        DCA_ROLLOVER: [
          "DCFSA",
          "Dependent care expenses",
          "If it is offered then you are eligible",
          "You, and possibly your employer",
          "Your employer",
          "You can use only the balance of funds accrued in the account",
          "Yes, up to {{financialFSAMoneyRolloverAmount}} by {{financialFSAMoneyRolloverDate}}",
          "No",
        ],
        HRA: [
          "HRA",
          "See your employer’s plan rules",
          "If you choose a qualified medical plan offered by your employer",
          "Only your employer",
          "Your employer",
          "See your employer’s plan rules",
          "See your employer’s plan rules",
          "No",
        ],
      },
    },
  },
  ExplorerPlanComparisonTableWVClientDental: {
    IN_NETWORK: {
      heading: "Let’s compare your dental plans",
      tableHeading: "Compare your In-Network and Out-of-Network costs",
      tableHeaders: [
        "<strong>Services & Benefits</strong>",
        "<strong>Plan Year Deductible</strong> (per person) <br /> <0>(applies Type II and III services only)</0>",
        "<1>Maximum Deductible (per family)</1>",
        "<strong>Plan Year Maximum Benefit</strong> (per person)",
        "<strong>Ortho Lifetime Max</strong> (Paid over two plan years)",
        "<strong>Type I: Preventive Dental Services</strong>",
        "<strong>Type II: Basic Dental Services</strong>",
        "<strong>Type III: Major Dental Services</strong>",
        "<strong>Type IV: Orthodontic Services</strong> <br /> <0>No orthodontic treatment age limitation</0>",
        "<strong>Treatment for TMJ Disorder</strong> <br /> <0>Non-Surgical TMJ treatment $1,000 lifetime maximum</0>",
      ],
      0: [
        "<strong>ASSISTANCE <br /> plan</strong>",
        "$25",
        "$75",
        "$750",
        "Not Covered",
        "Plan pays 100%",
        "Plan pays 40%",
        "Plan pays 25%",
        "Not Covered",
        "Not Covered",
      ],
      1: [
        "<strong>BASIC <br /> plan</strong>",
        "$25",
        "$75",
        "$1,000",
        "Not Covered",
        "Plan pays 100%",
        "Plan pays 75%",
        "Plan pays 40%",
        "Not Covered",
        "Not Covered",
      ],
      2: [
        "<strong>ENHANCED <br /> plan</strong>",
        "$50",
        "$150",
        "$1,500",
        "$1,250",
        "Plan pays 100%",
        "Plan pays 80%",
        "Plan pays 60%",
        "Plan pays 40%",
        "Plan pays 60%",
      ],
      3: [
        "<0><strong>NEW</strong></0> <br /> <strong>PREMIER plan</strong>",
        "$75",
        "$225",
        "$2,500",
        "$2,500",
        "Plan pays 100%",
        "Plan pays 90%",
        "Plan pays 75%",
        "Plan pays 50%",
        "Plan pays 75%",
      ],
      planMessage: `
      <p>For a complete description of services and waiting periods, please review your certificate of insurance.
      If you were covered under your employer’s prior plan the wait will be waived for any type of service covered under the prior plan and this plan.</p>	
      
      <p>• No waiting period for preventive or basic services	 • 6 months for major services • 6 months for orthodontic services</p>`,
    },
    OUT_NETWORK: {
      heading: "Let’s compare your dental plans",
      tableHeading: "Compare your In-Network and Out-of-Network costs",
      tableHeaders: [
        "<strong>Services & Benefits</strong>",
        "<strong>Plan Year Deductible</strong> (per person) <br /> <0>(applies Type II and III services only)</0>",
        "<1>Maximum Deductible (per family)</1>",
        "<strong>Plan Year Maximum Benefit</strong> (per person)",
        "<strong>Ortho Lifetime Max</strong> (Paid over two plan years)",
        "<strong>Type I: Preventive Dental Services</strong>",
        "<strong>Type II: Basic Dental Services</strong>",
        "<strong>Type III: Major Dental Services</strong>",
        "<strong>Type IV: Orthodontic Services</strong> <br /> <0>No orthodontic treatment age limitation</0>",
        "<strong>Treatment for TMJ Disorder</strong> <br /> <0>Non-Surgical TMJ treatment $1,000 lifetime maximum</0>",
      ],
      0: [
        "<strong>ASSISTANCE <br /> plan</strong>",
        "$25",
        "$75",
        "$500",
        "Not Covered",
        "Plan pays 80%",
        "Plan pays 25%",
        "Plan pays 10%",
        "Not Covered",
        "Not Covered",
      ],
      1: [
        "<strong>BASIC <br /> plan</strong>",
        "$25",
        "$75",
        "$500",
        "Not Covered",
        "Plan pays 80%",
        "Plan pays 50%",
        "Plan pays 25%",
        "Not Covered",
        "Not Covered",
      ],
      2: [
        "<strong>ENHANCED <br /> plan</strong>",
        "$50",
        "$150",
        "$1,000",
        "$500",
        "Plan pays 80%",
        "Plan pays 60%",
        "Plan pays 40%",
        "Plan pays 25%",
        "Plan pays 40%",
      ],
      3: [
        "<0><strong>NEW</strong></0> <br /> <strong>PREMIER plan</strong>",
        "$75",
        "$225",
        "$1,500",
        "$1,000",
        "Plan pays 80%",
        "Plan pays 70%",
        "Plan pays 50%",
        "Plan pays 50%",
        "Plan pays 50%",
      ],
      planMessage: `
      <p>For a complete description of services and waiting periods, please review your certificate of insurance.
      If you were covered under your employer’s prior plan the wait will be waived for any type of service covered under the prior plan and this plan.</p>	
      
      <p>• No waiting period for preventive or basic services	 • 6 months for major services • 6 months for orthodontic services</p>`,
    },
  },
  ExplorerBenefitHelpfulHint: {
    MEDICAL: {
      default: {
        default: {
          tip: '"Many plans cover preventive services at nearly 100%. Preventive services are a key step to good health and wellbeing."',
          description: "Frank, Benefit Counselor of 28 years",
        },
      },
    },
    DENTAL: {
      PPO: {
        default: {
          tip: '"A dental plan can help lower your out-of-pocket expenses so you can maintain a healthy smile and better overall health, too."',
          description: "Frank, Benefit Counselor of 28 years",
        },
        "Sun Life": {
          tip: '"You can save money by using an in-network dentist!"',
          description: "Frank, Benefit Counselor of 28 years",
        },
      },
      ASO_PPO: {
        default: {
          tip: '"A dental plan can help lower your out-of-pocket expenses so you can maintain a healthy smile and better overall health, too."',
          description: "Frank, Benefit Counselor of 28 years",
        },
        "Sun Life": {
          tip: '"You can save money by using an in-network dentist!"',
          description: "Frank, Benefit Counselor of 28 years",
        },
      },
      INDEMNITY: {
        default: {
          tip: '"A dental plan can help lower your out-of-pocket expenses so you can maintain a healthy smile and better overall health, too."',
          description: "Frank, Benefit Counselor of 28 years",
        },
        "Sun Life": {
          tip: '"Make sure to check if your plan covers preventive services at 100%. Many plans do so to encourage oral health."',
          description: "Frank, Benefit Counselor of 28 years",
        },
      },
      DHMO: {
        default: {
          tip: '"A dental plan can help lower your out-of-pocket expenses so you can maintain a healthy smile and better overall health, too."',
          description: "Adam, Benefit Counselor of 11 years",
        },
        "Sun Life": {
          tip: '"Benefits are even payable for pre-existing dental conditions within the copayment schedule."',
          description: "Adam, Benefit Counselor of 11 years",
        },
      },
      MULTI_CHOICE: {
        "Sun Life": {
          tip: '"Our plans come with access to the Dental Health Center. You can find average dental procedure costs and ask dentists questions."',
          description: "Pam, Benefit Counselor of 21 years",
        },
        default: {
          tip: '"A dental plan can help lower your out-of-pocket expenses so you can maintain a healthy smile and better overall health, too."',
          description: "Pam, Benefit Counselor of 21 years",
        },
      },
      default: {
        default: {
          tip: '"Our plans come with access to the Dental Health Center. You can find average dental procedure costs and ask dentists questions."',
          description: "Pam, Benefit Counselor of 21 years",
        },
      },
    },
    VISION: {
      default: {
        default: {
          tip: '"The biggest benefit of vision insurance is it covers or reduces the cost of eye exams. By using in-network providers, the savings can really add up."',
          description: "Pam, Benefit Counselor of 21 years",
        },
      },
    },
    ACCIDENT: {
      default: {
        default: {
          tip: '"Accidents can happen anytime, anywhere to anyone. This plan pays cash benefits directly to you above and beyond your medical insurance."',
          description: "Adam, Benefit Counselor of 11 years",
        },
      },
    },
    HOSPITAL_INDEMNITY: {
      default: {
        default: {
          tip: '"Hospital stays can be very expensive, even after your medical insurance pays their portion. Hospital Indemnity can help with things like deductibles or even your daily bills."',
          description: "Frank, Benefit Counselor of 28 years",
        },
      },
    },
    LIFE: {
      default: {
        default: {
          tip: '"Getting coverage at work is the easiest way to do it! Many plans offer coverage up to a certain amount without any health questions."',
          description: "Adam, Benefit Counselor of 11 years",
        },
      },
    },
    CRITICAL_ILLNESS: {
      default: {
        default: {
          tip: `"The rising costs of medical bills make us all nervous. {{alternateName}} insurance can help protect you from possible bankruptcy due to medical bills.`,
          description: "Adam, Benefit Counselor of 11 years",
        },
      },
    },
    CANCER: {
      default: {
        default: {
          tip: "\"Cancer insurance doesn't replace your health insurance, but it can help pay some of the expenses that aren't covered. Even things like lodging and transportation.\"",
          description: "Frank, Benefit Counselor of 28 years",
        },
      },
    },
    SHORT_TERM_DISABILITY: {
      default: {
        default: {
          tip: '"Living paycheck to paycheck right now? STD insurance can help keep you afloat if you can\'t work for a few weeks or months."',
          description: "Adam, Benefit Counselor of 11 years",
        },
      },
    },
    LONG_TERM_DISABILITY: {
      default: {
        default: {
          tip: '"Do you have enough savings to cover more than 3-6 months of expenses? If not, LTD insurance can help provide the income you count on."',
          description: "Pam, Benefit Counselor of 21 years",
        },
      },
    },
    GAP: {
      default: {
        default: {
          tip: '"This plan is an easy way to supplement your employer’s major medical plan without having to answer any health questions."',
          description: "Pam, Benefit Counselor of 21 years",
        },
      },
    },
  },
  ExplorerBenefitHowToUsePlan: {
    header_one: "How to use your plan",
    header_other: "How to use your {{planType}} plan",
    pillStatus: "STEP {{step}}",
    DHMO_TX: "Prepaid Dentists",
    DHMO_FL: "Prepaid Dentists",
    DENTAL: {
      DHMO: [
        {
          header: "Select a dentist",
          description: "Choose your network dentist at enrollment.",
        },
        {
          header: "Visit the dentist",
          description:
            "Get your cleanings, exams, x-rays, fillings, or other treatments from your assigned dentist.",
        },
        {
          header: "Approval & payment",
          description:
            "Pay the dentist according to your copay schedule and that’s it. There are no claims to file with this dental plan.",
        },
      ],
      default: [
        {
          header: "Visit the dentist",
          description:
            "Get your cleanings, exams, x-rays, fillings, or other treatments from your dentist.",
        },
        {
          header: "File a claim",
          description: "Most dental providers will file your claim for you.",
        },
        {
          header: "Approval & payment",
          description:
            "After claim approval, the dental provider will receive payment. The amount depends on the coverage you elected. For most preventive services, like cleanings, you won’t owe anything.",
        },
      ],
    },
    MEDICAL: {
      default: [
        {
          header: "Enroll",
          description:
            "Some plans may require you to choose a primary care doctor at time of enrollment.",
        },
        {
          header: "Go to doctor",
          description: "Get your annual physical or other treatment from your doctor.",
        },
        {
          header: "Payment",
          description:
            "Some plans might require a copay at time of service. Many doctors will file a claim with your insurance company on your behalf.",
        },
      ],
    },
    VISION: {
      default: [
        {
          header: "Visit an eye care doctor",
          description:
            "Get your eye care related services such as an eye exam, frames and/or lens appointment.",
        },
        {
          header: "File a <br /> claim",
          description:
            "Your eye doctor will file your claim for you. For some services, you will have a copay at your appointment.",
        },
        {
          header: "Approval & <br /> payment",
          description:
            "After claim approval, the eye doctor will receive payment. The amount depends on the coverage you elected.",
        },
      ],
    },
    ACCIDENT: {
      default: [
        {
          header: "File a claim",
          description:
            "If you or any covered family member has a qualifying event, file a simple claim.",
        },
        {
          header: "Approval and payment",
          description:
            "After claim approval, you will receive your check. The amount depends on the coverage you elected and the schedule of benefits.",
        },
        {
          header: "Spend it",
          description:
            "Use the money however you want. It can help with bills, groceries, childcare or anything else.",
        },
      ],
    },
    HOSPITAL_INDEMNITY: {
      default: [
        {
          header: "File a claim",
          description:
            "If you or any covered family member has a qualifying event, file a simple claim online.",
        },
        {
          header: "Approval and payment",
          description:
            "After claim approval, you will receive your check. The amount depends on the coverage you elected and the schedule of benefits.",
        },
        {
          header: "Spend it",
          description:
            "Use the money however you want. It can help with bills, groceries, childcare or anything else.",
        },
      ],
    },
    LIFE: {
      default: [
        {
          header: "File a claim",
          description: "If you or a covered family member{{add}} passes away, file a simple claim.",
          "AD&D": " has an accidental injury or",
        },
        {
          header: "Approval and payment",
          description:
            "After claim approval, you or the beneficiary will receive the check. The amount depends on the coverage you elected.",
        },
        {
          header: "Spend it",
          description:
            "Use the money for anything. It can help with bills, groceries, childcare or anything else.",
        },
      ],
    },
    CRITICAL_ILLNESS: {
      default: [
        {
          header: "File a claim",
          description:
            "If you or any covered family member has a qualifying diagnosis, file a simple claim",
        },
        {
          header: "Approval and payment",
          description:
            "After claim approval, you will receive your check. The amount depends on the coverage you elected and the schedule of benefits.",
        },
        {
          header: "Spend it",
          description:
            "Use the money however you want. It can help with bills, groceries, childcare or anything else.",
        },
      ],
    },
    CANCER: {
      default: [
        {
          header: "File a claim",
          description:
            "If you or a covered family member gets a covered treatment or service, file a simple claim.",
        },
        {
          header: "Approval and payment",
          description:
            "After claim approval, you will receive your check. The amount depends on the coverage you elected and the schedule of benefits.",
        },
        {
          header: "Spend it",
          description:
            "Use the money however you want. It can help with bills, groceries, childcare, or anything else.",
        },
      ],
    },
    SHORT_TERM_DISABILITY: {
      default: [
        {
          header: "File a claim",
          description:
            "If you have a covered disability, file a simple claim. We’ll ask you and your doctor to provide information about your medical condition and your expected recovery.",
        },
        {
          header: "Approval & <br /> payment",
          description:
            "After claim approval, you will start receiving your weekly check. The amount depends on the coverage you elected. ",
        },
        {
          header: "Spend it",
          description:
            "Use the money however you want. It can help with bills, groceries, childcare, or anything else. ",
        },
      ],
    },
    LONG_TERM_DISABILITY: {
      default: [
        {
          header: "File a claim",
          description:
            "If you have a covered disability, file a simple claim. We’ll ask you and your doctor to provide information about your medical condition and your expected recovery.",
        },
        {
          header: "Approval & <br /> payment",
          description:
            "After claim approval, you will start receiving your monthly check. The amount depends on the coverage you elected. ",
        },
        {
          header: "Spend it",
          description:
            "Use the money however you want. It can help with bills, groceries, childcare, or anything else. ",
        },
      ],
    },
    GAP: {
      default: [
        {
          header: "File a claim",
          description:
            "If you or any covered family has a qualifying expense, file a simple claim.",
        },
        {
          header: "Approval and payment",
          description:
            "After claim approval, you will receive your check. The amount depends on the coverage you elected and your medical insurance plan.",
        },
        {
          header: "Spend it",
          description:
            "Use the money to help with out-of-pocket medical expenses or anything else.",
        },
      ],
    },
  },
  ExplorerBenefitFaq: {
    heading: "FAQs",
    DHMO_TX: "Prepaid Dentists",
    DHMO_FL: "Prepaid Dentists",
    dentalClaimsNumber: " at 800-442-7742",
    MEC_MESSAGE: "* Does not apply to MEC plans",
    MEDICAL: {
      default: {
        default: [
          {
            question: "Will I be able to go to my current doctor?",
            answer:
              "Being able to continue to see your doctor is very important to most people. Whether you are able to depends on the plan offered. Please review the plan summary document above for a link to in-network doctors.",
          },
          {
            question: "What is the out-of-pocket maximum I could have to pay?",
            answer:
              "An out-of-pocket maximum lets you know the maximum you could pay if you have a major medical event. These can be around $5,000 - $6,000 but vary by plan. Please review the plan summary document above for your specific out-of-pocket maximum.",
          },
          {
            question: "Are preventive services covered at 100%?",
            answer:
              "Many plans cover preventive services at 100% to encourage you to get annual physicals and other screenings. When offered, this plan benefit can help lower your medical costs. Please review the plan summary document above to see how the plan covers preventive services.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
        MEC: [],
        MEC_COMBINED: [
          {
            question: "Will I be able to go to my current doctor?*",
            answer:
              "Being able to continue to see your doctor is very important to most people. Whether you are able to depends on the plan offered. Please review the plan summary document above for a link to in-network doctors.",
          },
          {
            question: "What is the out-of-pocket maximum I could have to pay?*",
            answer:
              "An out-of-pocket maximum lets you know the maximum you could pay if you have a major medical event. These can be around $5,000 - $6,000 but vary by plan. Please review the plan summary document above for your specific out-of-pocket maximum.",
          },
          {
            question: "Are preventive services covered at 100%?*",
            answer:
              "Many plans cover preventive services at 100% to encourage you to get annual physicals and other screenings. When offered, this plan benefit can help lower your medical costs. Please review the plan summary document above to see how the plan covers preventive services.",
          },
          {
            question: "Where can I find the cost of the plan?*",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
    },
    DENTAL: {
      "Sun Life": {
        PPO: [
          {
            question: "Do I have to choose a dentist in your network?",
            answer:
              "<p>No. You can visit any licensed dentist for services. However, you could see lower out-of-pocket costs when you visit a dentist in the network.</p><p>Please review your plan summary document to see if benefits are different for in-network and out-of-network dentists.</p>",
          },
          {
            question:
              "What if I have already started dental work, like a root canal or braces, that requires several visits?",
            answer:
              "Your coverage with us may handle these procedures differently than your prior plan. To ensure a smooth transition for work in progress, call our dental claims experts before your next visit{{numberCopy}}.",
          },
          {
            question: "Do I need approval for procedures before they are started?",
            answer:
              "You don’t need approval. We do recommend a pre-determination for any treatment over {{amountCopy}}. This way you will know what part the plan should cover, and how much you may need to pay.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
        ASO_PPO: [
          {
            question: "Do I have to choose a dentist in your network?",
            answer:
              "<p>No. You can visit any licensed dentist for services. However, you could see lower out-of-pocket costs when you visit a dentist in the network.</p><p>Please review your plan summary document to see if benefits are different for in-network and out-of-network dentists.</p>",
          },
          {
            question:
              "What if I have already started dental work, like a root canal or braces, that requires several visits?",
            answer:
              "Your coverage with us may handle these procedures differently than your prior plan. To ensure a smooth transition for work in progress, call our dental claims experts before your next visit{{numberCopy}}.",
          },
          {
            question: "Do I need approval for procedures before they are started?",
            answer:
              "You don’t need approval. We do recommend a pre-determination for any treatment over {{amountCopy}}. This way you will know what part the plan should cover, and how much you may need to pay.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
        DHMO: [
          {
            question: "How does a {{planName}} plan work?",
            answer:
              "This plan gives you and your family access to a range of dental services from in-network providers at fixed copay amounts. A copay is the set fee that you pay to the plan dentist at the time of treatment for covered services that are being performed. To receive services at these fixed rates, you must use a network provider.",
          },
          {
            question: "Do I have to choose a dentist in the network?",
            answer:
              "Yes. To receive the fixed copayment amounts you must visit a dentist in the network, and you must select the dentist in advance. Each family member may choose a different plan dentist.",
          },
          {
            question: "If I have a dental emergency, do I need to see my plan dentist?",
            answer:
              "First, contact your plan dentist to make an appointment. If your plan dentist is unable to see you, you may seek treatment from any licensed dentist in the United States. Please be informed that the emergency benefit of your plan is limited to the temporary relief of pain and has limited benefits.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
        INDEMNITY: [
          {
            question: "Do I have to choose a dentist in your network?",
            answer:
              "<p>No. You can visit any licensed dentist for services. However, you could see lower out-of-pocket costs when you visit a dentist in the network.</p><p>Please review your plan summary document to see if benefits are different for in-network and out-of-network dentists.</p>",
          },
          {
            question:
              "What if I have already started dental work, like a root canal or braces, that requires several visits?",
            answer:
              "Your coverage with us may handle these procedures differently than your prior plan. To ensure a smooth transition for work in progress, call our dental claims experts before your next visit{{numberCopy}}.",
          },
          {
            question: "Do I need approval for procedures before they are started?",
            answer:
              "You don’t need approval. We do recommend a pre-determination for any treatment over {{amountCopy}}. This way you will know what part the plan should cover, and how much you may need to pay.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
      default: {
        PPO: [
          {
            question: "Do I have to choose a dentist in your network?",
            answer:
              "<p>No. You can visit any licensed dentist for services. However, you could see lower out-of-pocket costs when you visit a dentist in the network.</p><p>Please review your plan summary document to see if benefits are different for in-network and out-of-network dentists.</p>",
          },
          {
            question:
              "What if I have already started dental work, like a root canal or braces, that requires several visits?",
            answer:
              "Your new plan may handle these procedures differently than your prior plan. For specific details on how this will work, please review the plan summary document above.",
          },
          {
            question: "Do I need approval for procedures before they are started?",
            answer:
              "With most plans you won’t need approval before a procedure is started. Please see your plan summary document above for more details.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
        ASO_PPO: [
          {
            question: "Do I have to choose a dentist in your network?",
            answer:
              "<p>No. You can visit any licensed dentist for services. However, you could see lower out-of-pocket costs when you visit a dentist in the network.</p><p>Please review your plan summary document to see if benefits are different for in-network and out-of-network dentists.</p>",
          },
          {
            question:
              "What if I have already started dental work, like a root canal or braces, that requires several visits?",
            answer:
              "Your new plan may handle these procedures differently than your prior plan. For specific details on how this will work, please review the plan summary document above.",
          },
          {
            question: "Do I need approval for procedures before they are started?",
            answer:
              "With most plans you won’t need approval before a procedure is started. Please see your plan summary document above for more details.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
        DHMO: [
          {
            question: "How does a {{planName}} plan work?",
            answer:
              "This plan gives you and your family access to a range of dental services from in-network providers at fixed copay amounts. A copay is the set fee that you pay to the plan dentist at the time of treatment for covered services that are being performed. To receive services at these fixed rates, you must use a network provider.",
          },
          {
            question: "Do I have to choose a dentist in the network?",
            answer:
              "Yes. To receive the fixed copayment amounts you must visit a dentist in the network, and you must select the dentist in advance. Each family member may choose a different plan dentist.",
          },
          {
            question: "If I have a dental emergency, do I need to see my plan dentist?",
            answer:
              "First, contact your plan dentist to make an appointment. If your plan dentist is unable to see you, you may seek treatment from any licensed dentist in the United States. Please be informed that the emergency benefit of your plan is limited to the temporary relief of pain and has limited benefits.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
        INDEMNITY: [
          {
            question: "Do I have to choose a dentist in your network?",
            answer:
              "<p>No. You can visit any licensed dentist for services. However, you could see lower out-of-pocket costs when you visit a dentist in the network.</p><p>Please review your plan summary document to see if benefits are different for in-network and out-of-network dentists.</p>",
          },
          {
            question:
              "What if I have already started dental work, like a root canal or braces, that requires several visits?",
            answer:
              "Your new plan may handle these procedures differently than your prior plan. For specific details on how this will work, please review the plan summary document above.",
          },
          {
            question: "Do I need approval for procedures before they are started?",
            answer:
              "With most plans you won’t need approval before a procedure is started. Please see your plan summary document above for more details.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
    },
    VISION: {
      default: {
        default: [
          {
            question: "What happens if I use an out-of-network doctor?",
            answer:
              "For some plans you may be required to pay the full amount to the doctor at time of service. You would then submit a claim for reimbursement, which is a lesser benefit when compared to visiting an in-network doctor. Please see your plan summary document above for more details.",
          },
          {
            question: "Can I use this insurance with retail providers like Costco or Walmart?",
            answer:
              "It depends on the plan being offered. Many plans include coverage at retail providers. Please review your plan summary document to see if retail providers are included.",
          },
          {
            question: "Can I use my benefits to buy glasses or contacts online?",
            answer:
              "Many plans include coverage to buy glasses and contacts online. For specific details about your plan, please see the plan summary document above. ",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
      "Sun Life": {
        default: [
          {
            question: "What happens if I use an out-of-network doctor?",
            answer:
              "You will be required to pay the full amount to the doctor at time of service. You can then submit a claim for reimbursement, which is a lesser benefit when compared to visiting a VSP doctor.",
          },
          {
            question: "Can I use this insurance with retail providers like Costco or Walmart?",
            answer:
              "It depends on the plan being offered. We do have plans that include coverage at retail providers. Please review your plan summary document to see if retail providers are included.",
          },
          {
            question: "Can I use my benefits to buy glasses or contacts online?",
            answer:
              "Absolutely. Just visit www.eyeconic.com. Once you have linked your benefits you will be able to see how your coverage will be applied to different options that you are reviewing. Eyeconic features a virtual try-on tool so you can see how the glasses will look on you before you make your purchase.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
    },
    ACCIDENT: {
      default: {
        default: [
          {
            question: "How does this work with my health insurance?",
            answer:
              "<p>Accident insurance complements but does not replace your health insurance. With accident insurance, the cash benefits come directly to you, not your healthcare provider. You decide how best to use the money. You can use it to pay for copays, your ride to urgent care, a babysitter, or your internet bill. Whatever you need.</p><p>Payout amounts depend on the types of treatments you receive and claim for a covered accident. Plus, you can still receive payouts when your health insurance plan covers 100% of the medical bills.</p>",
          },
          {
            question: "What’s not covered in this plan?",
            answer: `
              <p>Many accident plans do not cover things like:</p>
              <0>
                <0>Treatments or services received due to sickness or disease rather than an accident.</0>
                <0>Injuries caused by activities that are reckless or dangerous.</0>
                <0>Injuries that occur while under the influence of certain drugs or alcohol.</0>
                <0>Injuries that happened before you buy your accident insurance plan.</0>
              </0>
              For specific details on what is not covered, view your plan summary document above.
            `,
          },
          {
            question: "How many times can I get a payout?",
            answer:
              "Let’s say you have a bike accident and take an ambulance to the hospital in January. Then later in the year, you suffer an accident at home and also need an ambulance.<br/><br/> In this case, you would receive benefits for both ambulance rides – once for each covered accident.<br/><br/>Many of the accident plan benefit payouts could pay you once for each accident. However, certain benefits pay only once for each <strong><i>benefit year</i></strong> rather than for each covered accident. For more details about plan payouts, view your plan summary document above.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
      "Sun Life": {
        default: [
          {
            question: "How does this work with my health insurance?",
            answer:
              "<p>Accident insurance complements but does not replace your health insurance. With accident insurance, the cash benefits come directly to you, not your healthcare provider. You decide how best to use the money. You can use it to pay for copays, your ride to urgent care, a babysitter, or your internet bill. Whatever you need.</p><p>Payout amounts depend on the types of treatments you receive and claim for a covered accident. Plus, you can still receive payouts when your health insurance plan covers 100% of the medical bills.</p>",
          },
          {
            question: "What’s not covered in this plan?",
            answer: `
              <p>The plan does not cover:</p>
              <0>
                <0>Treatments or services received due to sickness or disease rather than an accident.</0>
                <0>Injuries caused by activities that are reckless or dangerous.</0>
                <0>Injuries that occur while under the influence of certain drugs or alcohol.</0>
                <0>Injuries that happened before you buy your accident insurance plan.</0>
              </0>
              For more details on what is not covered, view your plan summary document above.
            `,
          },
          {
            question: "How many times can I get a payout?",
            answer:
              "Let’s say you have a bike accident and take an ambulance to the hospital in January. Then later in the year, you suffer an accident at home and also need an ambulance.<br/><br/> In this case, you would receive benefits for both ambulance rides – once for each covered accident.<br/><br/>Many of the accident plan benefit payouts could pay you once for each accident. However, certain benefits pay only once for each <strong><i>benefit year</i></strong> rather than for each covered accident. For more details about plan payouts, view your plan summary document above.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
    },
    HOSPITAL_INDEMNITY: {
      default: {
        default: [
          {
            question: "How does this work with my health insurance?",
            answer: `Hospital Indemnity insurance pays in addition to your health insurance. It complements but does not replace your health insurance. <br /><br /> With hospital indemnity insurance, you can receive payouts for hospital stays due to covered accidents or sickness. The cash benefits come directly to you, rather than your healthcare provider. <br /><br /> You decide how best to use the money. You can use it to pay for bills, your ride to urgent care, a babysitter, or your internet bill. Whatever you need.`,
          },
          {
            question: "If I’m admitted to a hospital, is that considered a hospital stay?",
            answer:
              "It is if your inpatient stay is at least the minimum number of continuous hours required under your plan. This is typically around 20 hours. <br /><br /> For more details on hospital stays, view your plan summary document above.",
          },
          {
            question: "How is pregnancy covered?",
            answer:
              "Many plans cover hospital stays due to complications of pregnancy, but only certain plans also cover routine pregnancy. Plans that cover hospital stays due to a routine pregnancy or childbirth may include a waiting period. <br /><br /> For specific details on how this plan covers pregnancy, view your plan summary document above.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
      "Sun Life": {
        default: [
          {
            question: "How does this work with my health insurance?",
            answer: `Hospital Indemnity insurance pays in addition to your health insurance. It complements but does not replace your health insurance. <br /><br /> With hospital indemnity insurance, you can receive payouts for hospital stays due to covered accidents or sickness. The cash benefits come directly to you, rather than your healthcare provider. <br /><br /> You decide how best to use the money. You can use it to pay for bills, your ride to urgent care, a babysitter, or your internet bill. Whatever you need.`,
          },
          {
            question: "If I’m admitted to a hospital, is that considered a hospital stay?",
            answer:
              "It is if your inpatient stay is at least the minimum number of continuous hours required under your plan. This is typically around 20 hours. <br /><br /> For more details on hospital stays, view your plan summary document above.",
          },
          {
            question: "How is pregnancy covered?",
            answer:
              "Our plans cover hospital stays due to complications of pregnancy, but only certain plans also cover routine pregnancy. Plans that cover hospital stays due to a routine pregnancy or childbirth may include a waiting period. <br /><br /> For more details on how this plan covers pregnancy, view your plan summary document above.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
    },
    LIFE: {
      "Sun Life": {
        default: [
          {
            question: "Do I need to answer health questions to enroll?",
            answer:
              "It depends on your plan design. Many plans offer coverage up to a certain amount without health questions. Please see your plan summary above to learn more.",
          },
          {
            question: "Can I take my insurance with me if I leave my employer?",
            answer:
              "Depending on state variations and your employer’s plan, you may be able to continue coverage after you leave. Your employer can advise you about your options.",
          },
          {
            question: "Can I access my life insurance if I become terminally ill?",
            answer:
              "You might be able to. Many plans allow you to receive a portion of your life insurance to help cover medical and living expenses. We call it an “Accelerated Death Benefit”. Please review your plan summary above to see how it would work for your plan.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
      default: {
        default: [
          {
            question: "Do I need to answer health questions to enroll?",
            answer:
              "It depends on your plan design. Many plans offer coverage up to a certain amount without health questions. Please see your plan summary above to learn more.",
          },
          {
            question: "Can I take my insurance with me if I leave my employer?",
            answer:
              "Depending on state variations and your employer’s plan, you may be able to continue coverage after you leave. Your employer can advise you about your options.",
          },
          {
            question: "Can I access my life insurance if I become terminally ill?",
            answer:
              "You might be able to. Many plans allow you to receive a portion of your life insurance to help cover medical and living expenses. Please review your plan summary above to see how it would work for your plan.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
    },
    CRITICAL_ILLNESS: {
      default: {
        default: [
          {
            question: "How does this work with my health insurance?",
            answer:
              "{{alternateName}} insurance complements but does not replace your health insurance. With {{alternateName, lowercase}} insurance, a lump sum cash benefit comes directly to you, rather than your healthcare provider. You decide how best to use the money. You can use the cash to pay for your deductible, a babysitter, or your internet bill. Whatever you need. <br /><br /> Payout amounts depend on the level of coverage you select. Plus, you can still receive payouts when your health insurance plan covers 100% of the medical bills.",
          },
          {
            question: "How many times can I receive a payout?",
            answer:
              "It depends on your {{alternateName, lowercase}} plan. To receive more than one payout, your plan may require a certain amount of time between each diagnosis. <br /><br /> Let’s say you have a heart attack and then a year later, you get a cancer diagnosis. You could receive payouts for the first event (heart attack) as well as for the second diagnosis (cancer). <br /><br /> For more details about how many payouts you could receive, view your plan summary document above.",
          },
          {
            question: "What if I get diagnosed with the same illness again?",
            answer:
              "Most plans offer a recurrence benefit. If yours does, you could receive another payout for the same diagnosis. Your plan may require a certain amount of time between each diagnosis. Not all covered conditions qualify for the recurrence benefit so be sure to check what qualifies. <br /><br /> Review your plan summary document to see if your plan includes the recurrence benefit.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
    },
    CANCER: {
      default: {
        default: [
          {
            question: "How does this work with my health insurance?",
            answer:
              "Cancer insurance complements but does not replace your health insurance. <br /><br /> With cancer insurance, you can receive payouts for a range of cancer-related services and treatments. Things like screenings, to diagnoses of cancer, and treatments and services along the way to your recovery. These cash benefits come directly to you, rather than your healthcare provider. <br /><br /> You decide how best to use the money. You can use the cash to pay for your deductible, your ride to urgent care, or your internet bill. Whatever you need.",
          },
          {
            question: "How do payouts work?",
            answer:
              "The payouts you receive for different treatments or services will depend on the type of service and your plan. For example, a payout for a cancer screening is once per year. While a payout for radiation treatments may be a certain amount per week up to an annual maximum.<br /><br />For more details on payouts, view your plan summary document above.",
          },
          {
            question: "What’s not covered in this plan?",
            answer: `
          <p>
            Many cancer plans do not cover things like: 
          </p>
          <0>
            <0>A diagnosis of cancer that is active on your effective date</0>
            <0>Treatments or services for premalignant conditions, non-cancer illnesses or elective plastic or cosmetic surgery (other than reconstructive surgery)</0>
          </0>
          <p>For specific details on what is not covered, view your plan summary document above.</p>
          `,
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
      "Sun Life": {
        default: [
          {
            question: "How does this work with my health insurance?",
            answer:
              "Cancer insurance complements but does not replace your health insurance. <br /><br /> With cancer insurance, you can receive payouts for a range of cancer-related services and treatments. Things like screenings, to diagnoses of cancer, and treatments and services along the way to your recovery. These cash benefits come directly to you, rather than your healthcare provider. <br /><br /> You decide how best to use the money. You can use the cash to pay for your deductible, your ride to urgent care, or your internet bill. Whatever you need.",
          },
          {
            question: "How do payouts work?",
            answer:
              "The payouts you receive for different treatments or services will depend on the type of service and your plan. For example, a payout for a cancer screening is once per year. While a payout for radiation treatments may be a certain amount per week up to an annual maximum.<br /><br />For more details on payouts, view your plan summary document above.",
          },
          {
            question: "What’s not covered in this plan?",
            answer: `
          <p>
            This cancer plan does not cover:
          </p>
          <0>
            <0>A diagnosis of cancer that is active on your effective date</0>
            <0>Treatments or services for premalignant conditions, non-cancer illnesses or elective plastic or cosmetic surgery (other than reconstructive surgery)</0>
          </0>
          <p>This plan pays based on a fixed schedule of benefits and may not cover all the treatments you receive.</p>
          <p>For more details on what is not covered, view your plan summary document above.</p>
          `,
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
    },
    SHORT_TERM_DISABILITY: {
      default: {
        default: [
          {
            question: "Do I need to answer health questions to enroll?",
            answer:
              "It depends on your plan design. Many plans offer coverage up to a certain amount without health questions. Please see your plan summary above to learn more.",
          },
          {
            question: "Will income from other sources affect my benefit?",
            answer:
              "Yes, it could. Your benefit may be reduced by Social Security benefits; disability benefits from retirement, government plans or state disability income; state paid family and medical leaves; other group disability plans; no-fault benefits, salary continuance or sick leave; and return-to-work earnings.",
          },
          {
            question: "Can I work while I am disabled?",
            answer:
              "It depends on your plan. With some plans you can work part-time and still receive part of your benefits while working. Please see your plan summary document to learn more.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
    },
    LONG_TERM_DISABILITY: {
      default: {
        default: [
          {
            question: "Can I work while I am disabled?",
            answer:
              "Many plans encourage and support your return to work. If you can work part-time, for example, you could still receive part of your benefits while working. <br /><br />Please see your plan summary above to learn more.",
          },
          {
            question: "Will income from other sources affect my benefit?",
            answer:
              "Yes, it could. Your benefit may be reduced by Social Security benefits; disability benefits from retirement, government plans or state disability income; other group disability plans; no-fault benefits, salary continuance or sick leave; and return-to-work earnings.",
          },
          {
            question: "Do I need to answer health questions to enroll?",
            answer:
              "It depends on your plan design. Many plans offer coverage up to a certain amount without health questions. Please see your plan summary above to learn more.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
      "Sun Life": {
        default: [
          {
            question: "Can I work while I am disabled?",
            answer:
              "Your plan encourages and supports your return to work. If you can work part-time, for example, you would still receive part of your benefits while working.",
          },
          {
            question: "Will income from other sources affect my benefit?",
            answer:
              "Yes, it could. Your benefit may be reduced by Social Security benefits; disability benefits from retirement, government plans or state disability income; other group disability plans; no-fault benefits, salary continuance or sick leave; and return-to-work earnings.",
          },
          {
            question: "Do I need to answer health questions to enroll?",
            answer:
              "It depends on your plan design. Many plans offer coverage up to a certain amount without health questions. Please see your plan summary above to learn more.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
    },
    GAP: {
      default: {
        default: [
          {
            question: "Do I need to answer any medical questions?",
            answer:
              "No. You can sign up for this coverage without answering medical questions. You must apply within 31 days of the date you meet your employer’s eligible requirements.",
          },
          {
            question: "How are physician charges handled?",
            answer:
              "Physician charges that occur while a person is hospital confined are payable under the inpatient benefit. Please see the plan summary document for more details.",
          },
          {
            question: "Are hospital nursery well-baby charges covered?",
            answer: "No. The plan only pays for benefits for sickness or injury.",
          },
          {
            question: "Where can I find the cost of the plan?",
            answer:
              "You can find specific plan costs on your benefits administration platform or other materials your employer provides. Click the 'Sign in and enroll' link to find more information or reach out to your HR Benefits Administrator.",
          },
        ],
      },
    },
  },
  PersonalBenefitsPlanHeadline: {
    header_empty: "Favorite plans so they <br/>show up here.",
    header: "Don’t forget to enroll",
    subHeader_empty:
      "When you’re ready, send yourself or a loved one a reminder of which plans you like.",
    subHeader:
      "Want a reminder of these benefits during your enrollment? <br/> Send yourself or a loved one a reminder.",
    oeBanner:
      "Open Enrollment is from <strong>{{oeStart, longMonthDayDate}} - {{oeEnd, longMonthDayDate}}</strong>",
    hrLinkBanner: "Visit <0>{{hrAdminURL}}</0> when you’re ready to enroll in benefits.",
    printHeader: "Your Personal Benefits Plan {{year}}",
    feedbackTitle: "Email Sent!",
    feedbackConfirmTitle: "Thanks for the feedback!",
    feedbackConfirmBody:
      "If you are finished learning about your benefits and now want to enroll, follow the button below.",
    feedbackConfirmCTA: "Sign in & Enroll",
    emailCTA: "Send Email",
    backButton: "Back",
    downloadText: "Download your plan",
    printOrDownloadText: "Print or download your plan <0>here</0>",
  },
  ExplorerBenefitHowMuchCoverage: {
    header: "How much coverage to get",
    description: `
      <0>
        3-5 years of salary is usually a good idea for people with many shared expenses. This will give your loved ones some money and time to keep moving forward.
      </0>
      <1>
        Enter your salary to the right to see how much coverage you might need.
      </1>`,
  },
  ExplorerBenefitCoverageCalculator: {
    header: "Coverage Calculator",
    "3_years": "x 3 years",
    "5_years": "x 5 years",
    description:
      "For a relatively low monthly cost, you could protect your loved ones for thousands of dollars.",
  },
  ExplorerBenefitADD: {
    header: "This plan includes coverage for AD&D",
    description: `
    <0>
      You would get a payout if you or a covered dependent has an accidental death or injury. <br/> <br/>
      Here are some examples: 
    </0>
    <1>
      <0>quadriplegia</0>
      <0>loss of sight, speech or hearing</0>
      <0>loss of a limb (arm or leg)</0>
      <0>loss of a thumb and index finger on the same hand</0>
    </1>`,
  },
  ExplorerBenefitWellness: {
    CANCER: {
      header: "Includes {{amount}} Cancer Screening Benefit<sup>1</sup>",
      description: `
      <0>
        There are many tests covered like chest x-rays, pap smears or mammograms. It is easy to file a claim online in just a few minutes. <br /><br /> All covered family members are eligible for this benefit each year.
      </0>`,
      showTotal: true,
      familyMembers: 2,
      amountCaption: "WELLNESS BENEFIT",
      familyMembersCaption: "# OF FAMILY MEMBERS",
      totalAmountCaption: "EVERY YEAR",
    },
    HOSPITAL_INDEMNITY: {
      header: "Receive {{amount}} cash for wellness steps you may already be taking<sup>1</sup>",
      description: `
      <0>
        There are over 30 tests covered like flu shots or cholesterol tests. It is easy to file a claim online in just a few minutes. <br /><br /> All covered family members are eligible for the benefit each year.
      </0>`,
      showTotal: true,
      familyMembers: 2,
      amountCaption: "WELLNESS BENEFIT",
      familyMembersCaption: "# OF FAMILY MEMBERS",
      totalAmountCaption: "EVERY YEAR",
    },
    CRITICAL_ILLNESS: {
      header: "Receive {{amount}} cash for wellness steps you may already be taking<sup>1</sup>",
      description: `
      <0>
      There are nearly 20 tests covered like flu shots or cholesterol tests. It is easy to file a claim online in just a few minutes. <br /><br /> All covered family members are eligible for the benefit each year.
      </0>`,
      showTotal: true,
      familyMembers: 2,
      amountCaption: "WELLNESS BENEFIT",
      familyMembersCaption: "# OF FAMILY MEMBERS",
      totalAmountCaption: "EVERY YEAR",
    },
    ACCIDENT: {
      header: "Receive {{amount}} cash for wellness steps you may already be taking<sup>1</sup>",
      description: `
      <0>
        There are nearly 20 tests covered like flu shots or cholesterol tests. It is easy to file a claim online in just a few minutes. <br /><br /> All covered family members are eligible for the benefit each year.
      </0>`,
      showTotal: true,
      familyMembers: 2,
      amountCaption: "WELLNESS BENEFIT",
      familyMembersCaption: "# OF FAMILY MEMBERS",
      totalAmountCaption: "EVERY YEAR",
    },
  },
  ExplorerLocationModal: {
    header: "Welcome to Benefits Explorer!",
    description:
      "Let's get started reviewing your benefits! To begin, select the state you live in. You'll then see the benefits available for that location.",
    editHeader: "Need to change your location?",
    editDescription:
      "Select the state you live in from the drop-down list. You'll then see the benefits available for that location.",
    saveButton: "Submit",
    cancelButton: "Cancel",
    message:
      "Changing your state may change the dental plans available to you and may remove a favorite dental plan from your Personal Benefits Plan.",
  },
  ExplorerPage: {
    locationHeading: "Viewing plans for {{location}}. ",
    locationHeadingNoBenefits:
      "There are no {{carrierName}} DHMO Dental plans available in {{location}}. ",
    scrollToButtonText: "Top",
    changeLocationText: "Change your location",
    newEmployees: "New Employees",
    prevPageLink: "Access {{planYear}} benefit enrollment",
  },
  BenefitInterstitialDivider: {
    chat: {
      header: "Need more guidance? {{sunLifeCopy}}Benefit Counselors are here to help.",
      subHeader1: "Benefit Counselors are available M-F, 8 a.m. - 8 p.m., Eastern Time (ET)",
      subHeader2: "Holiday schedules may vary.",
      callToAction: "Chat now",
    },
    "one-on-one": {
      header: "Prefer to meet with a Benefit Counselor one-to-one?",
      callToAction: "Schedule call",
    },
    SMS: {
      header: "Want a text reminder when your enrollment begins?",
      callToAction: "Sign up for text notifications",
    },
  },
  EndFavoritePlans: {
    headline_one: "You favorited {{plansCount}} plan",
    headline_other: "You favorited {{plansCount}} plans",
    buttonText: "Review your Personal Benefits Plan",
    feedbackSuccess: "Your feedback has been recorded.",
  },
  EndOfBenefits: {
    headline: "That’s it!",
    content: `<0>
        You’ve reached the end of reviewing your benefits from {{client}}. 
      </0>
      <1></1>
      <2>
        Have questions? You can schedule a private session with a seasoned benefit counselor. They are available over the phone or on a Zoom meeting.
      </2>`,
    buttonText: "Schedule now",
  },
  ExplorerBenefit: {
    MEDICAL: {
      disclaimer_prefix: "Disclaimer: ",
      disclaimer_1: "{{planNames.0}} benefit plan is insured or administered by {{legalEntity}}. ",
      disclaimer_2:
        "{{planNames.0}} and {{planNames.1}} benefit plans are insured or administered by {{legalEntity}}. ",
      disclaimer_many:
        "{{plansList}}, and {{lastPlan}} benefit plans are insured or administered by {{legalEntity}}. ",
      legal: "The medical insurance plans described above are for your information only. ",
      PLAN_COMPARISON: {
        disclaimer_prefix: "About the health plan(s): ",
        disclaimer_1:
          "{{planNames.0}} benefit plan is insured or administered by {{legalEntity}}. ",
        disclaimer_2:
          "{{planNames.0}} and {{planNames.1}} benefit plans are insured or administered by {{legalEntity}}.",
        disclaimer_many:
          "{{plansList}}, and {{lastPlan}} benefit plans are insured or administered by {{legalEntity}}",
        legal:
          "The medical insurance plans described above are for your information only. For detailed information about these benefit plans you should refer to the issuing company material linked in the table above or contact your benefits administrator.",
      },
    },
    DENTAL: {
      legal:
        'Read the "Important Information" section for more details by scrolling to the bottom of the screen.',
      legal_nonSL: "The dental insurance plans described above are for your information only.",
      disclaimer_prefix: "Disclaimer: ",
      disclaimer_1: "{{planNames.0}} benefit plan is insured or administered by {{legalEntity}}. ",
      disclaimer_2:
        "{{planNames.0}} and {{planNames.1}} benefit plans are insured or administered by {{legalEntity}}. ",
      disclaimer_many:
        "{{plansList}}, and {{lastPlan}} benefit plans are insured or administered by {{legalEntity}}. ",
    },
    VISION: {
      legal:
        'Administrative services for the vision insurance plan are provided by Vision Service Plan (VSP).<br/>Read the "Important Information" section for more details by scrolling to the bottom of the screen.',
      legal_nonSL: "The vision insurance plans described above are for your information only.",
      disclaimer_prefix: "Disclaimer: ",
      disclaimer_1: "{{planNames.0}} benefit plan is insured or administered by {{legalEntity}}. ",
      disclaimer_2:
        "{{planNames.0}} and {{planNames.1}} benefit plans are insured or administered by {{legalEntity}}. ",
      disclaimer_many:
        "{{plansList}}, and {{lastPlan}} benefit plans are insured or administered by {{legalEntity}}. ",
    },
    ACCIDENT: {
      legal:
        'Read the "Important Information" section for more details by scrolling to the bottom of the screen.',
      legal_nonSL: "The accident insurance plans described above are for your information only.",
      disclaimer_prefix: "Disclaimer: ",
      disclaimer_1: "{{planNames.0}} benefit plan is insured or administered by {{legalEntity}}. ",
      disclaimer_2:
        "{{planNames.0}} and {{planNames.1}} benefit plans are insured or administered by {{legalEntity}}. ",
      disclaimer_many:
        "{{plansList}}, and {{lastPlan}} benefit plans are insured or administered by {{legalEntity}}. ",
    },
    HOSPITAL_INDEMNITY: {
      legal:
        'Read the "Important Information" section for more details by scrolling to the bottom of the screen.',
      legal_nonSL:
        "The hospital indemnity insurance plans described above are for your information only.",
      disclaimer_prefix: "Disclaimer: ",
      disclaimer_1: "{{planNames.0}} benefit plan is insured or administered by {{legalEntity}}. ",
      disclaimer_2:
        "{{planNames.0}} and {{planNames.1}} benefit plans are insured or administered by {{legalEntity}}. ",
      disclaimer_many:
        "{{plansList}}, and {{lastPlan}} benefit plans are insured or administered by {{legalEntity}}. ",
    },
    CANCER: {
      legal:
        'Read the "Important Information" section for more details by scrolling to the bottom of the screen.',
      legal_nonSL: "The cancer insurance plans described above are for your information only.",
      disclaimer_prefix: "Disclaimer: ",
      disclaimer_1: "{{planNames.0}} benefit plan is insured or administered by {{legalEntity}}. ",
      disclaimer_2:
        "{{planNames.0}} and {{planNames.1}} benefit plans are insured or administered by {{legalEntity}}. ",
      disclaimer_many:
        "{{plansList}}, and {{lastPlan}} benefit plans are insured or administered by {{legalEntity}}. ",
    },
    CRITICAL_ILLNESS: {
      legal:
        'Read the "Important Information" section for more details by scrolling to the bottom of the screen.',
      legal_nonSL:
        "The critical illness insurance plans described above are for your information only. ",
      disclaimer_prefix: "Disclaimer: ",
      disclaimer_1: "{{planNames.0}} benefit plan is insured or administered by {{legalEntity}}. ",
      disclaimer_2:
        "{{planNames.0}} and {{planNames.1}} benefit plans are insured or administered by {{legalEntity}}. ",
      disclaimer_many:
        "{{plansList}}, and {{lastPlan}} benefit plans are insured or administered by {{legalEntity}}. ",
    },
    GAP: {
      legal:
        'Gap insurance is underwritten by Fidelity Security Life Insurance Company®.<br/>*Read the "Important Information" section for more details by scrolling to the bottom of the screen.',
    },
    SHORT_TERM_DISABILITY: {
      legal:
        'Read the "Important Information" section for more details by scrolling to the bottom of the screen.',
      legal_nonSL: "The disability insurance plans described above are for your information only.",
      disclaimer_prefix: "Disclaimer: ",
      disclaimer_1: "{{planNames.0}} benefit plan is insured or administered by {{legalEntity}}. ",
      disclaimer_2:
        "{{planNames.0}} and {{planNames.1}} benefit plans are insured or administered by {{legalEntity}}. ",
      disclaimer_many:
        "{{plansList}}, and {{lastPlan}} benefit plans are insured or administered by {{legalEntity}}. ",
    },
    LONG_TERM_DISABILITY: {
      legal:
        'Read the "Important Information" section for more details by scrolling to the bottom of the screen.',
      legal_nonSL: "The disability insurance plans described above are for your information only.",
      disclaimer_prefix: "Disclaimer: ",
      disclaimer_1: "{{planNames.0}} benefit plan is insured or administered by {{legalEntity}}. ",
      disclaimer_2:
        "{{planNames.0}} and {{planNames.1}} benefit plans are insured or administered by {{legalEntity}}. ",
      disclaimer_many:
        "{{plansList}}, and {{lastPlan}} benefit plans are insured or administered by {{legalEntity}}. ",
    },
    LIFE: {
      legal:
        'Read the "Important Information" section for more details by scrolling to the bottom of the screen.',
      legal_nonSL: "The life insurance plans described above are for your information only.",
      disclaimer_prefix: "Disclaimer: ",
      disclaimer_1: "{{planNames.0}} benefit plan is insured or administered by {{legalEntity}}. ",
      disclaimer_2:
        "{{planNames.0}} and {{planNames.1}} benefit plans are insured or administered by {{legalEntity}}. ",
      disclaimer_many:
        "{{plansList}}, and {{lastPlan}} benefit plans are insured or administered by {{legalEntity}}. ",
    },
    FINANCIAL: {
      legal: "The financial products described above are for your information only.",
    },
    OTHER: {
      legal: "The additional benefits described above are for your information only.",
    },
  },
  ExplorerDisclaimers: {
    header: "Important Information",
    disclaimer_collapsed: "Expand to view disclaimers",
    disclaimer_expanded: "Collapse disclaimers",
    exclusionsAndLimitations_collapsed: "Expand to view limitations and exclusions",
    exclusionsAndLimitations_expanded: "Collapse limitations and exclusions",
    disclaimer_prefix: "<strong>Disclaimers:</strong> ",
    exclusionsAndLimitations_prefix: "<strong>Limitations and exclusions:</strong> ",
    CANCER: {
      header: "Cancer Insurance",
      disclaimer: {
        "Sun Life": {
          default: {
            default: {
              content:
                "1. Cancer screening is payable once per covered person, per contract year. May not be available in all states.<br/><br/>This coverage does not constitute comprehensive health insurance (often referred to as “major medical coverage”) and does not satisfy the requirement for Minimum Essential Coverage under the Affordable Care Act. <br/><br/>Cancer insurance is a limited benefit policy. It does NOT provide basic hospital, basic medical, or major medical insurance. The certificate has exclusions, limitations, and benefit waiting periods for certain conditions (as detailed in the certificate) that may affect any benefits payable. Benefits payable are subject to all terms and conditions of the certificate. The policy, certificate and rider, if applicable, may not be available in all states and may vary based on state laws and regulations. This overview is preliminary to the issuance of the policy and certificate. Not available for use in NY.  <br/><br/>Cancer insurance policies are underwritten by Sun Life Assurance Company of Canada (Wellesley Hills, MA) in all states, except New York, under Policy Form Series 15-GP-01, 16-CAN-C-01, and 16-CANPort-C-01. Product offerings may not be available in all states and may vary depending on state laws and regulations.",
            },
          },
        },
      },
      exclusionsAndLimitations: {
        "Sun Life": {
          default: {
            WY: {
              content:
                "We will not pay a benefit that is due to or results from: services or Treatment not included in the Covered Cancer Benefits; war or an act of war; active military duty; intentionally self-inflicted injuries while sane or insane; services or Treatment for which the Insured is not charged, unless there is no charge because the facility is a United States government facility; services or Treatment provided by a Family Member; services or Treatment for premalignant conditions; services or Treatment for conditions with malignant potential; services or Treatment for non-cancer illnesses; elective plastic or cosmetic surgery. <br/><br/>This product is inappropriate for individuals who are eligible for Medicaid coverage. <br/><br/>RIGHT TO RETURN <br/><br/>If you are not satisfied, you may return the certificate to your Employer within 30 days after receipt. Your Employer will refund the amount of premium you have paid provided no claim has been incurred during the 30-day period. Your certificate will then be void, as though you had never applied for the insurance.",
            },
            AZ: {
              content:
                "Limitations and exclusions: The following exclusions and limitations may vary by state law and regulations. This list may not be comprehensive. Please see the Certificate or ask your benefits administrator for details. We will not pay a benefit that is due to or results from: services or Treatment not included in the Covered Cancer Benefits; war or an act of war; active military duty; intentionally self-inflicted injuries while sane or insane; services or Treatment for which the Insured is not charged, unless there is no charge because the facility is a United States government facility; services or Treatment provided by a Family Member; services or Treatment for premalignant conditions; services or Treatment for conditions with malignant potential; services or Treatment for non-cancer illnesses; elective plastic or cosmetic surgery.",
            },
          },
        },
      },
    },
    DENTAL: {
      header: "{{alternateName}}",
      disclaimer: {
        "Sun Life": {
          DHMO: {
            AZ: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. Annual cost used is an average and not specific to the plans you are being offered.<br/><br/>This dental plan does not provide coverage for pediatric oral health services that satisfies the requirements for “minimum essential coverage” as defined by the Patient Protection and Affordable Care Act. (“PPACA”).<br/><br/>Prepaid dental products are provided and administered by Sun Life Assurance Company of Canada (SLOC) under Form Series BDC-GDSA, PDC, and are provided by prepaid dental companies, affiliated with SLOC, under Form Series BDC-GDSA, UDC-CA-GA06-UDC, UDC-CA-GA06-89, FB-NJ-0281, UDC-09-GDSA-TX, PDC in certain states except New York. Prepaid dental companies are Denticare of Alabama, Inc., United Dental Care of Arizona, Inc., UDC Dental California, Inc., United Dental Care of Colorado, Inc., Union Security DentalCare of Georgia, Inc., United Dental Care of Missouri, Inc., Union Security DentalCare of New Jersey, Inc., United Dental Care of New Mexico, Inc., UDC Ohio, Inc., United Dental Care of Texas, Inc., and United Dental Care of Utah, Inc. In New York, prepaid dental products are provided and administered by Sun Life and Health Insurance Company (U.S.) (SLHIC) (Lansing, MI) under Form Series BDC-GDSA-NY. Product offerings may not be available in all states and may vary depending on state laws and regulations.",
            },
            NM: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. Annual cost used is an average and not specific to the plans you are being offered.<br/><br/>This dental plan does not provide coverage for pediatric oral health services that satisfies the requirements for “minimum essential coverage” as defined by the Patient Protection and Affordable Care Act. (“PPACA”).<br/><br/>Prepaid dental products are provided and administered by Sun Life Assurance Company of Canada (SLOC) under Form Series BDC-GDSA, PDC, and are provided by prepaid dental companies, affiliated with SLOC, under Form Series BDC-GDSA, UDC-CA-GA06-UDC, UDC-CA-GA06-89, FB-NJ-0281, UDC-09-GDSA-TX, PDC in certain states except New York. Prepaid dental companies are Denticare of Alabama, Inc., United Dental Care of Arizona, Inc., UDC Dental California, Inc., United Dental Care of Colorado, Inc., Union Security DentalCare of Georgia, Inc., United Dental Care of Missouri, Inc., Union Security DentalCare of New Jersey, Inc., United Dental Care of New Mexico, Inc., UDC Ohio, Inc., United Dental Care of Texas, Inc., and United Dental Care of Utah, Inc. In New York, prepaid dental products are provided and administered by Sun Life and Health Insurance Company (U.S.) (SLHIC) (Lansing, MI) under Form Series BDC-GDSA-NY. Product offerings may not be available in all states and may vary depending on state laws and regulations. This policy has exclusions, limitations and terms under which the policy may be continued in force or discontinued. For cost and complete details of the coverage, please contact the company.",
            },
            default: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. Annual cost used is an average and not specific to the plans you are being offered.<br/><br/>This dental plan does not provide coverage for pediatric oral health services that satisfies the requirements for “minimum essential coverage” as defined by the Patient Protection and Affordable Care Act. (“PPACA”).<br/><br/>Prepaid dental products are provided and administered by Sun Life Assurance Company of Canada (SLOC) under Form Series BDC-GDSA, PDC, and are provided by prepaid dental companies, affiliated with SLOC, under Form Series BDC-GDSA, UDC-CA-GA06-UDC, UDC-CA-GA06-89, FB-NJ-0281, UDC-09-GDSA-TX, PDC in certain states except New York. Prepaid dental companies are Denticare of Alabama, Inc., United Dental Care of Arizona, Inc., UDC Dental California, Inc., United Dental Care of Colorado, Inc., Union Security DentalCare of Georgia, Inc., United Dental Care of Missouri, Inc., Union Security DentalCare of New Jersey, Inc., United Dental Care of New Mexico, Inc., UDC Ohio, Inc., United Dental Care of Texas, Inc., and United Dental Care of Utah, Inc. In New York, prepaid dental products are provided and administered by Sun Life and Health Insurance Company (U.S.) (SLHIC) (Lansing, MI) under Form Series BDC-GDSA-NY. Product offerings may not be available in all states and may vary depending on state laws and regulations.",
            },
          },
          PPO: {
            NY: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.<br/><br/>This dental plan does not provide coverage for pediatric oral health services that satisfies the requirements for “minimum essential coverage” as defined by the Patient Protection and Affordable Care Act. (“PPACA”).<br/><br/>In New York, group insurance policies are underwritten by Sun Life and Health Insurance Company (U.S.) (Lansing, MI) under Policy Form Series 15-GP-01 and 16-DEN-C-01. Product offerings may not be available in all states and may vary depending on state laws and regulations.",
            },
            default: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.<br/><br/>This dental plan does not provide coverage for pediatric oral health services that satisfies the requirements for “minimum essential coverage” as defined by the Patient Protection and Affordable Care Act. (“PPACA”).<br/><br/>Group insurance policies are underwritten by Sun Life Assurance Company of Canada (Wellesley Hills, MA) in all states, except New York, under Policy Form Series 15-GP-01 and 16-DEN-C-01. Product offerings may not be available in all states and may vary depending on state laws and regulations.",
            },
          },
          ASO_PPO: {
            default: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.<br/><br/>This dental plan does not provide coverage for pediatric oral health services that satisfies the requirements for “minimum essential coverage” as defined by the Patient Protection and Affordable Care Act. (“PPACA”).<br/><br/>Product offerings may not be available in all states and may vary depending on state laws and regulations.<br/><br/>In all states except New York, Administrative Services Only services for self-funded dental plans are administered by Sun Life Assurance Company of Canada (Wellesley Hills, MA). In New York, they are administered by Sun Life and Health Insurance Company (U.S.) (Lansing, MI).",
            },
          },
          INDEMNITY: {
            NY: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.<br/><br/>This dental plan does not provide coverage for pediatric oral health services that satisfies the requirements for “minimum essential coverage” as defined by the Patient Protection and Affordable Care Act. (“PPACA”).<br/><br/>In New York, group insurance policies are underwritten by Sun Life and Health Insurance Company (U.S.) (Lansing, MI) under Policy Form Series 15-GP-01 and 16-DEN-C-01. Product offerings may not be available in all states and may vary depending on state laws and regulations.",
            },
            default: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.<br/><br/>This dental plan does not provide coverage for pediatric oral health services that satisfies the requirements for “minimum essential coverage” as defined by the Patient Protection and Affordable Care Act. (“PPACA”).<br/><br/>Group insurance policies are underwritten by Sun Life Assurance Company of Canada (Wellesley Hills, MA) in all states, except New York, under Policy Form Series 15-GP-01 and 16-DEN-C-01. Product offerings may not be available in all states and may vary depending on state laws and regulations.",
            },
          },
          MULTI_CHOICE: {
            AZ: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.<br/><br/>These dental plans do not provide coverage for pediatric oral health services that satisfies the requirements for “minimum essential coverage” as defined by the Patient Protection and Affordable Care Act. (“PPACA”).<br/><br/>Group insurance policies are underwritten by Sun Life Assurance Company of Canada (SLOC) (Wellesley Hills, MA) in all states, except New York, under Policy Form Series 15-GP-01 and 16-DEN-C-01. Prepaid dental products are provided and administered by SLOC under Form Series BDC-GDSA, PDC, and are provided by prepaid dental companies, affiliated with SLOC, under Form Series BDC-GDSA, UDC-CA-GA06-UDC, UDC-CA-GA06-89, FB-NJ-0281, UDC-09-GDSA-TX, PDC in certain states except New York. Prepaid dental companies are Denticare of Alabama, Inc., United Dental Care of Arizona, Inc., UDC Dental California, Inc., United Dental Care of Colorado, Inc., Union Security DentalCare of Georgia, Inc., United Dental Care of Missouri, Inc., Union Security DentalCare of New Jersey, Inc., United Dental Care of New Mexico, Inc., UDC Ohio, Inc., United Dental Care of Texas, Inc., and United Dental Care of Utah, Inc. Product offerings may not be available in all states and may vary depending on state laws and regulations.",
            },
            NM: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.<br/><br/>These dental plans do not provide coverage for pediatric oral health services that satisfies the requirements for “minimum essential coverage” as defined by the Patient Protection and Affordable Care Act. (“PPACA”).<br/><br/>Group insurance policies are underwritten by Sun Life Assurance Company of Canada (SLOC) (Wellesley Hills, MA) in all states, except New York, under Policy Form Series 15-GP-01 and 16-DEN-C-01. Prepaid dental products are provided and administered by SLOC under Form Series BDC-GDSA, PDC, and are provided by prepaid dental companies, affiliated with SLOC, under Form Series BDC-GDSA, UDC-CA-GA06-UDC, UDC-CA-GA06-89, FB-NJ-0281, UDC-09-GDSA-TX, PDC in certain states except New York. Prepaid dental companies are Denticare of Alabama, Inc., United Dental Care of Arizona, Inc., UDC Dental California, Inc., United Dental Care of Colorado, Inc., Union Security DentalCare of Georgia, Inc., United Dental Care of Missouri, Inc., Union Security DentalCare of New Jersey, Inc., United Dental Care of New Mexico, Inc., UDC Ohio, Inc., United Dental Care of Texas, Inc., and United Dental Care of Utah, Inc. Product offerings may not be available in all states and may vary depending on state laws and regulations. This policy has exclusions, limitations and terms under which the policy may be continued in force or discontinued. For cost and complete details of the coverage, please contact the company.",
            },
            NY: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.<br/><br/>These dental plans do not provide coverage for pediatric oral health services that satisfies the requirements for “minimum essential coverage” as defined by the Patient Protection and Affordable Care Act. (“PPACA”).<br/><br/>Group insurance policies are underwritten by Sun Life Assurance Company of Canada (SLOC) (Wellesley Hills, MA) in all states, except New York, under Policy Form Series 15-GP-01 and 16-DEN-C-01. Prepaid dental products are provided and administered by SLOC under Form Series BDC-GDSA, PDC, and are provided by prepaid dental companies, affiliated with SLOC, under Form Series BDC-GDSA, UDC-CA-GA06-UDC, UDC-CA-GA06-89, FB-NJ-0281, UDC-09-GDSA-TX, PDC in certain states except New York. Prepaid dental companies are Denticare of Alabama, Inc., United Dental Care of Arizona, Inc., UDC Dental California, Inc., United Dental Care of Colorado, Inc., Union Security DentalCare of Georgia, Inc., United Dental Care of Missouri, Inc., Union Security DentalCare of New Jersey, Inc., United Dental Care of New Mexico, Inc., UDC Ohio, Inc., United Dental Care of Texas, Inc., and United Dental Care of Utah, Inc. In New York, group insurance policies are underwritten by Sun Life and Health Insurance Company (U.S.) (SLHIC) (Lansing, MI) under Policy Form Series 15-GP-01, 16-DEN-C-01 and prepaid dental products are provided and administered by SLHIC under Form Series BDC-GDSA-NY. Product offerings may not be available in all states and may vary depending on state laws and regulations.",
            },
            default: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.<br/><br/>These dental plans do not provide coverage for pediatric oral health services that satisfies the requirements for “minimum essential coverage” as defined by the Patient Protection and Affordable Care Act. (“PPACA”).<br/><br/>Group insurance policies are underwritten by Sun Life Assurance Company of Canada (SLOC) (Wellesley Hills, MA) in all states, except New York, under Policy Form Series 15-GP-01 and 16-DEN-C-01. Prepaid dental products are provided and administered by SLOC under Form Series BDC-GDSA, PDC, and are provided by prepaid dental companies, affiliated with SLOC, under Form Series BDC-GDSA, UDC-CA-GA06-UDC, UDC-CA-GA06-89, FB-NJ-0281, UDC-09-GDSA-TX, PDC in certain states except New York. Prepaid dental companies are Denticare of Alabama, Inc., United Dental Care of Arizona, Inc., UDC Dental California, Inc., United Dental Care of Colorado, Inc., Union Security DentalCare of Georgia, Inc., United Dental Care of Missouri, Inc., Union Security DentalCare of New Jersey, Inc., United Dental Care of New Mexico, Inc., UDC Ohio, Inc., United Dental Care of Texas, Inc., and United Dental Care of Utah, Inc. Product offerings may not be available in all states and may vary depending on state laws and regulations.",
            },
          },
        },
        default: {
          DHMO: {
            AZ: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. Annual cost used is an average and not specific to the plans you are being offered.",
            },
            default: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. Annual cost used is an average and not specific to the plans you are being offered.",
            },
          },
          PPO: {
            NY: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.",
            },
            default: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.",
            },
          },
          ASO_PPO: {
            default: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.",
            },
          },
          INDEMNITY: {
            NY: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.",
            },
            default: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.",
            },
          },
          MULTI_CHOICE: {
            AZ: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.",
            },
            NY: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.",
            },
            default: {
              content:
                "1. 2023 Fair Health data.<br/><br/>2. This is less a $25 deductible and with 80% coinsurance.<br/><br/>3. Annual cost used is an average and not specific to the plans you are being offered.",
            },
          },
        },
      },
      exclusionsAndLimitations: {
        "Sun Life": {
          DHMO: {
            AZ: {
              content:
                "The below exclusions and limitations may vary by state law and regulations. This list may not be comprehensive. Please see the Evidence of Coverage or ask your benefits administrator for details.<br/><br/>We will not pay a benefit for any Dental procedure or service not specifically mentioned in the Copayment Schedule (including any hospital or outpatient care facility cost associated with any dental procedures). Any dental service listed in the Copayment Schedule initiated prior to Member’s Effective Date or after the Member’s termination is not covered. Services provided by non-Plan Providers are not covered unless for Emergency Services specifically provided in the EMERGENCY SERVICES Article of the Evidence of Coverage. Fixed or removable prosthetics are subject to a 5 year replacement limitation. Extractions for Orthodontic purposes only are at a 25% discount off of the Plan Provider’s normal retail charge. Implants and implant related procedures are not covered. Orthodontic treatment involving therapy for myofunctional problems, TMJ (temporomandibular joint) dysfunctions, micrognathia, macroglossia, cleft palate or other growth and developmental abnormalities are not covered. Limitations and exclusions apply with respect to the Member’s oral conditions without regard to whether or not such conditions existed before the effective date of the Member’s enrollment.",
            },
          },
          MULTI_CHOICE: {
            AZ: {
              content:
                "Prepaid/DHMO Limitations and exclusions: The below exclusions and limitations may vary by state law and regulations. This list may not be comprehensive. Please see the Evidence of Coverage or ask your benefits administrator for details.<br/><br/>We will not pay a benefit for any Dental procedure or service not specifically mentioned in the Copayment Schedule (including any hospital or outpatient care facility cost associated with any dental procedures). Any dental service listed in the Copayment Schedule initiated prior to Member’s Effective Date or after the Member’s termination is not covered. Services provided by non-Plan Providers are not covered unless for Emergency Services specifically provided in the EMERGENCY SERVICES Article of the Evidence of Coverage. Fixed or removable prosthetics are subject to a 5 year replacement limitation. Extractions for Orthodontic purposes only are at a 25% discount off of the Plan Provider’s normal retail charge. Implants and implant related procedures are not covered. Orthodontic treatment involving therapy for myofunctional problems, TMJ (temporomandibular joint) dysfunctions, micrognathia, macroglossia, cleft palate or other growth and developmental abnormalities are not covered. Limitations and exclusions apply with respect to the Member’s oral conditions without regard to whether or not such conditions existed before the effective date of the Member’s enrollment. ",
            },
          },
        },
      },
    },
    CRITICAL_ILLNESS: {
      header: "{{alternateName}} Insurance",
      disclaimer: {
        "Sun Life": {
          default: {
            NY: {
              content:
                "1. Wellness Benefit is payable once per covered person, per contract year. May not be available in all states.<br/><br/>In New York, to be eligible for specified disease coverage, the Insured must also be covered under major medical, or at least basic hospital and basic medical insurance. This is a limited benefit policy. This coverage does not constitute comprehensive health insurance (often referred to as “major medical coverage”) and does not satisfy the requirement for Minimum Essential Coverage under the Affordable Care Act. The expected benefit ratio for this policy is 70%. This ratio is the portion of future premiums which the Company expects to return as benefits, when averaged over all people with the policy. The certificates have exclusions and limitations for certain conditions that may affect any benefits payable. Benefits payable are subject to all terms and conditions of the certificate. <br/><br/>Note regarding Employees Covered or Considering Coverage under Health Savings Accounts (HSA) Established in Connection with High Deductible Health Plans (HDHP): <br/><br/>Based on the limited available regulatory guidance, Sun Life believes its “Specified Disease insurance” is appropriate for use with an HSA and may be purchased when employees and/or their family members are covered under an HDHP. However, Sun Life cannot provide legal or tax advice. If there are legal or tax questions, we suggest that employees consult their own legal or tax advisor before purchasing this insurance. <br/><br/>In New York, Specified Disease insurance policies are underwritten by Sun Life and Health Insurance Company (U.S.) (Lansing, MI) under Policy Form Series 15-GP-01, 15-SD-GP-01, 16-SD-C-01, 16-SDPort-C-01, 12-GP-SD-01, 13-SD-C-01, 12-GPPort-01 and 13-SDPort-C-01. ",
            },
            default: {
              content:
                "1. Wellness Benefit is payable once per covered person, per contract year. May not be available in all states.<br/><br/>This coverage does not constitute comprehensive health insurance (often referred to as “major medical coverage”) and does not satisfy the requirement for Minimum Essential Coverage under the Affordable Care Act. <br/><br/>This {{alternateName, lowercase}} insurance policy provides limited benefits. This limited policy has some specific benefit limits and is not a medical insurance policy, a Medicare Supplement policy, or a high deductible health plan. Please refer to the issued insurance policy for complete details and all benefit requirements, including all limitations, exclusions, restrictions, waiting periods and reductions. We reserve the right to cancel the policy with advance written notice to the policyholder. Issued insurance contracts determine all plan features and benefits.  <br/><br/>Insurance products are underwritten by Sun Life Assurance Company of Canada (Wellesley Hills, MA) under Policy Form Series 15-GP-01, 16-SD-C-01 and 16-SDPort-C-01. Insurance policies and certain policy benefits are subject to state variations and may not be available in all states.",
            },
          },
        },
      },
      exclusionsAndLimitations: {
        "Sun Life": {
          default: {
            AZ: {
              content:
                "Limitations and exclusions: The following exclusions and limitations may vary by state law and regulations. This list may not be comprehensive. Please see the Certificate or ask your benefits administrator for details. We will not pay a benefit that is due to or results from: suicide while sane or insane; intentionally self-inflicted injuries; committing or attempting to commit an assault, felony or other criminal act; war or an act of war; active participation in a riot, rebellion or insurrection; voluntary use of any controlled substance/illegal drugs; operation of a motorized vehicle while intoxicated; if you do not submit proof of your loss as required by us (this covers medical examination, continuing care, death certificate, medical records, etc.); incarceration; a diagnosis that is not explicitly covered under the policy; a diagnosis that occurs prior to the effective date of coverage (unless it is a new and unrelated diagnosis that occurs after the effective date of coverage). Covered conditions have specific diagnostic criteria that must be met (along with supporting documentation) for a benefit to be paid. For additional information regarding covered conditions, please request an outline of coverage.",
            },
          },
        },
      },
    },
    VISION: {
      header: "Vision Insurance",
      disclaimer: {
        "Sun Life": {
          default: {
            NY: {
              content:
                "1. Based on the Choice Plan with a $130 frame allowance.<br /><br />2. Comparison based on national averages for comprehensive eye exams and most commonly purchased brands. This chart represents typical savings for VSP members. (09/24)<br /><br />This vision plan does not provide coverage for pediatric vision health services that satisfies the requirement for “minimum essential coverage” as defined by The Patient Protection and Affordable Care Act (“PPACA”).<br /><br />In New York, group insurance policies are underwritten by Sun Life and Health Insurance Company (U.S.) (Lansing, MI) under Policy Form Series 15-GP-01 and 16-VIS-C-01. Product offerings may not be available in all states and may vary depending on state laws and regulations. ",
            },
            default: {
              content:
                "1. Based on the Choice Plan with a $130 frame allowance.<br /><br />2. Comparison based on national averages for comprehensive eye exams and most commonly purchased brands. This chart represents typical savings for VSP members. (09/24)<br /><br />This vision plan does not provide coverage for pediatric vision health services that satisfies the requirement for “minimum essential coverage” as defined by The Patient Protection and Affordable Care Act (“PPACA”).<br /><br />Group insurance policies are underwritten by Sun Life Assurance Company of Canada (Wellesley Hills, MA) in all states, except New York, under Policy Form Series 15-GP-01 and 16-VIS-C-01. Product offerings may not be available in all states and may vary depending on state laws and regulations.",
            },
          },
        },
      },
      exclusionsAndLimitations: {
        "Sun Life": {
          default: {
            AZ: {
              content:
                "Limitations and exclusions: The following exclusions and limitations may vary by state law and regulations. This list may not be comprehensive. Please see your Certificate or ask your benefits administrator for details. We will not pay a benefit for any vision materials, services or options that are not shown in the Benefit Highlights section of the certificate. Any vision service incurred prior to the Effective date or after the termination date is not covered. A member must be a covered vision member under the Plan to receive vision benefits. In no event will benefits exceed the lesser of the actual cost of the examination or materials or the limits of coverage shown in the Benefit Highlights section of the certificate. The plan is designed to cover visually necessary materials rather than cosmetic materials; the member will be responsible for any additional costs above the basic cost.",
            },
          },
        },
      },
    },
    HOSPITAL_INDEMNITY: {
      header: "Hospital Indemnity Insurance",
      exclusionsAndLimitations: {
        "Sun Life": {
          default: {
            AZ: {
              content:
                "Exclusions: The following exclusions may vary by plan design, state law and regulations. This list may not be comprehensive. Please see the Certificate or ask your benefits administrator for details. No benefits will be payable relating to or resulting from services or treatment rendered or confinement outside the United States or Canada. No benefits will be payable for any loss that is caused or contributed to by: war or any act of war or your active duty in any armed service during a time of war (this does not include acts of terrorism); active military duty; riding in or driving any motor-driven vehicle in a race, stunt show, speed test or driving while Intoxicated; committing of or attempting to commit an assault, felony or other criminal act; active participation in a riot, rebellion or insurrection; committing or attempting to commit suicide, whether sane or insane, or injuring oneself intentionally; incarceration in a penal institution of any kind; pregnancy or childbirth, except complications of pregnancy; any mental and nervous disorder; substance abuse; a covered accident or covered sickness arising out of or in the course of any work for pay or profit; elective abortion or complications thereof; elective or cosmetic surgery or procedures, except for reconstructive surgery unless due to congenital anomaly or disease of a dependent child which has resulted in a defect; artificial insemination, in vitro fertilization, test tube fertilization; treatment, supplies or services provided by, through or, behalf of any government agency or program for which there is not normally any charge; or sterilization, tubal ligation or vasectomy, and reversal thereof, unless recommended by a physician.",
            },
          },
        },
      },
      disclaimer: {
        "Sun Life": {
          default: {
            NY: {
              content:
                "1. Wellness Benefit is payable once per covered person, per contract year. May not be available in all states.<br /><br />In New York, to be eligible for Hospital Indemnity Insurance coverage, the Insured must also be covered under major medical, or at least basic hospital and basic medical insurance. This is a limited benefit policy. This coverage does not constitute comprehensive health insurance (often referred to as “major medical coverage”) and does not satisfy the requirement for Minimum Essential Coverage under the Affordable Care Act. The certificate has exclusions, limitations, and benefit waiting periods for certain conditions that may affect any benefits payable. Benefits payable are subject to all terms and conditions of the certificate. The policy, certificate, and any rider, if applicable, may not be available in all states and may vary based on state laws and regulations.<br /><br />In New York, Group Hospital Indemnity Insurance coverage is underwritten by Sun Life and Health Insurance Company (U.S.) (Lansing, MI) under Policy Form Series 15-GP-01, 20-HI-C-01, 12-GPPort-P-01, 20-HIPORT-C-01. Insurance coverage and certain policy benefits may not be available in all states. Certain provisions, benefits, exclusions or limitations may vary by state. Plans contain limitations, exclusions and restrictions. Contact us for additional information.",
            },
            default: {
              content:
                "1. Wellness Benefit is payable once per covered person, per contract year. May not be available in all states.<br /><br />This is a limited benefit policy. It does NOT provide basic hospital, basic medical, or major medical insurance. It is not a Medicare Supplement policy. The certificate has exclusions, limitations, and benefit waiting periods for certain conditions that may affect any benefits payable. Benefits payable are subject to all terms and conditions of the certificate. The policy, certificate and any rider, if applicable, may not be available in all states and may vary based on state laws and regulations.<br /><br />Group Hospital Indemnity Insurance is underwritten by Sun Life Assurance Company of Canada (Wellesley Hills, MA) under Policy Form Series 15-GP-01, 20-HI-C-01, 12-GPPort-P-01, 20-HIPORT-C-01 in certain states.",
            },
          },
        },
      },
    },
    ACCIDENT: {
      header: "Accident Insurance",
      disclaimer: {
        "Sun Life": {
          default: {
            NY: {
              VAS: "2. Value-added services are offered only on specific lines of coverage and carry a separate charge, which is added to the cost of the insurance. The cost is included in the total amount billed.{{VAS_1}}",
              VAS_1:
                " Emergency Travel Assistance is provided by Assist America®. Identity Theft Protection is provided by SecurAssist®, an Assist America program. Sun Life is not responsible or liable for care, services, or advice given by any provider or vendor of the Services. Sun Life reserves the right to discontinue any of the Services at any time. <br /><br />This policy contains limitations and exclusions that may affect benefits. Please see the Certificate or ask your benefits administrator for information.",
              content:
                "1. Wellness Benefit is payable once per covered person, per contract year. May not be available in all states.<br /><br />Accident insurance is a limited benefit policy. It provides accident coverage only and does not provide basic hospital, basic medical, or major medical insurance. This coverage does not constitute comprehensive health insurance (often referred to as “major medical coverage”) and does not satisfy the requirement for Minimum Essential Coverage under the Affordable Care Act. Failing to maintain Minimum Essential Coverage may result in a tax penalty.<br /><br />The certificate and its riders have exclusions and limitations that may affect any benefits payable. Benefits payable are subject to all terms and conditions of the certificate. The policy, certificate, and any rider, if applicable, may not be available in all states.<br /><br />For New York consumers: The expected benefit ratio for this policy is 65%. This ratio is the portion of future premiums that the Company expects to return as benefits, when averaged over all people with the policy.<br /><br />In New York group accident insurance policies are underwritten by Sun Life and Health Insurance Company (U.S.) (Lansing, MI) under Policy Form Series 15-GP-01, 12-GP-01, 12-AC-C-01, 12-GPPort-01 and 12-ACPort-C-01. Product offerings may not be available in all states and may vary depending on state laws and regulations. <br /><br />{{VAS}}",
            },
            default: {
              VAS: "2. Value-added services are offered only on specific lines of coverage and carry a separate charge, which is added to the cost of the insurance. The cost is included in the total amount billed.{{VAS_1}}",
              VAS_1:
                " Emergency Travel Assistance is provided by Assist America®. Identity Theft Protection is provided by SecurAssist®, an Assist America program. Sun Life is not responsible or liable for care, services, or advice given by any provider or vendor of the Services. Sun Life reserves the right to discontinue any of the Services at any time. <br /><br />This policy contains limitations and exclusions that may affect benefits. Please see the Certificate or ask your benefits administrator for information.",
              content:
                "1. Wellness Benefit is payable once per covered person, per contract year. May not be available in all states.<br /><br />Accident insurance is a limited benefit policy. It provides accident coverage only and does not provide basic hospital, basic medical, or major medical insurance. This coverage does not constitute comprehensive health insurance (often referred to as “major medical coverage”) and does not satisfy the requirement for Minimum Essential Coverage under the Affordable Care Act. Failing to maintain Minimum Essential Coverage may result in a tax penalty.<br /><br />The certificate and its riders have exclusions and limitations that may affect any benefits payable. Benefits payable are subject to all terms and conditions of the certificate. The policy, certificate, and any rider, if applicable, may not be available in all states.<br /><br />Group accident insurance policies are underwritten by Sun Life Assurance Company of Canada (Wellesley Hills, MA) in all states, except New York, under Policy Form Series 16-AC-C-01, 16-ACPort-C-01, 15-GP-01, 12-GP-01, 12-AC-C-01, 12-GPPort-01 and 12-ACPort-C-01. Product offerings may not be available in all states and may vary depending on state laws and regulations. <br /><br />{{VAS}}",
            },
          },
        },
      },
    },
    GAP: {
      header: "{{alternateName}} Insurance",
      exclusionsAndLimitations: {
        default: {
          default: {
            default: {
              content:
                "Exclusions: The Policy does not provide any benefits for the following: any Expenses Incurred during any period the Insured Person does not have coverage under a Major Medical Plan; war, declared or undeclared; suicide or any attempt thereat, while sane or insane (in Colorado or Missouri, while sane); any intentionally self-inflicted Injury or Sickness, while sane or insane (in Colorado or Missouri, while sane); any loss while the Insured Person is in the service of the Armed Forces of any country. Orders to active military service for training purposes of two months or less will not constitute service in the Armed Forces. Upon notice to the Company of entering the Armed Forces, the Company will return to the Insured Person pro rata any premium paid, less any benefits paid, for any period during which the Insured Person is in such service; any expense for which there is no legal obligation to pay, no charge is made or in the absence of coverage, no charge would be made; Pregnancy of a Dependent child, except Complications of Pregnancy; dental or vision services unless: resulting from an Injury occurring while the Insured Person’s coverage under the Policy is in force; or due to congenital disease or anomaly of a Dependent newborn child; mental illness or functional or organic nervous disorders, regardless of the cause; treatment of alcoholism, drug addiction or complications thereof; any Injury that occurs while an Insured Person has been determined to be intoxicated: by judicial or administrative judgment or order; by evidence of an alcohol concentration in the Insured Person’s blood, breath or urine which equals or exceeds the limits set by applicable motor vehicle laws; or by other evidence demonstrating the Insured Person was under the influence of any alcohol, narcotic, barbiturate or hallucinatory drug, unless the same was administered on the advice of a Physician and was taken according to the prescribed dosage; and the use of such substance was a proximate cause of the Injury; Injury or Sickness for which compensation is payable under any Workers’ Compensation Law, any Occupational Disease Law or similar legislation; any loss for which the Insured Person is not required to pay a Deductible, Copayment and/or Coinsurance under the Insured Person’s Major Medical Plan; any expense for which benefits are excluded under the Insured Person’s Major Medical Plan; or an Insured Person engaging in any act or occupation which is a violation of the law of the jurisdiction where the loss or cause of loss occurred. A violation of law includes both misdemeanor and felony violations.<br/><br/>Limitations: Major Medical Plan. If an Insured Person did not have a Major Medical Plan on the Insured Person’s Effective Date under the Policy, the Company’s sole obligation will then be to refund all premiums paid for that Insured Person.<br/><br/>Hospital Confinements due to Pregnancy, termination of Pregnancy and Complications of Pregnancy are payable if the Pregnancy is payable under the Insured Person’s Major Medical/Comprehensive Policy. Benefits for Pregnancy and termination of Pregnancy under this provision are limited to an Insured or an Insured Dependent spouse.",
            },
          },
        },
      },
      disclaimer: {
        default: {
          default: {
            default: {
              content:
                "This {{alternateName}} Insurance policy provides limited benefits. This limited policy has some specific benefit limits and is not a major medical insurance policy, a Medicare Supplement policy, or a high deductible health plan. Please refer to the issued insurance policy for complete details and all benefit requirements. Group Hospital Confinement Indemnity “Gap” or Supplemental Medical Expense “Gap” insurance underwritten by Fidelity Security Life Insurance Company®, Kansas City, MO 64111, Group Master Policy MG-111 and MG-122; Group Policy form No. M-9054 and M-9111 and is sold by Sun Life Assurance Company of Canada under a marketing agreement. Insurance coverage and certain policy benefits may not be available in all states. Certain provisions, benefits, exclusions or limitations may vary by state. Plans contain limitations, exclusions and restrictions. Contact us for additional information.",
            },
          },
        },
      },
    },
    SHORT_TERM_DISABILITY: {
      header: "Short-Term Disability Insurance",
      disclaimer: {
        "Sun Life": {
          default: {
            NY: {
              link: "https://www.ssa.gov/news/press/factsheets/basicfact-alt.pdf",
              content:
                "1. <0>https://www.ssa.gov/news/press/factsheets/basicfact-alt.pdf</0> (accessed 04/21)<br /><br />2. In Vermont, the product name is Short-Term Income Replacement Insurance when the Maximum Benefit Duration elected is less than 26 weeks. <br /><br />3. Keep in mind that other sources of income could reduce your benefit amount This policy contains limitations and exclusions that may affect benefits. Please see the Certificate or ask your benefits administrator for information on Elimination Periods, Waiting Periods, and Pre-Existing Conditions limitations.<br /><br />This coverage does not constitute comprehensive health insurance (often referred to as “major medical coverage”) and does not satisfy the requirement for Minimum Essential Coverage under the Affordable Care Act.<br /><br />The group insurance policies described in this advertisement provide disability income insurance only. They do NOT provide basic hospital, basic medical, or major medical insurance as defined by the New York State Department of Financial Services. In New York, the expected benefit ratio for this policy is 65%.<br /><br />In New York, group insurance policies are underwritten by Sun Life and Health Insurance Company (U.S.) (Lansing, MI) under Policy Form Series 15-GP-01, 13-GP-LH-01, 13-LTD-C-01, 13-STD-C-01, 06P-NY-DBL, 12-GPPort-01, and 12-STDPort-C-01. Product offerings may not be available in all states and may vary depending on state laws and regulations. ",
            },
            default: {
              link: "https://www.ssa.gov/news/press/factsheets/basicfact-alt.pdf",
              content:
                "1. <0>https://www.ssa.gov/news/press/factsheets/basicfact-alt.pdf</0> (accessed 04/21)<br /><br />2. In Vermont, the product name is Short-Term Income Replacement Insurance when the Maximum Benefit Duration elected is less than 26 weeks.<br /><br />3. Keep in mind that other sources of income could reduce your benefit amount This policy contains limitations and exclusions that may affect benefits. Please see the Certificate or ask your benefits administrator for information on Elimination Periods, Waiting Periods, and Pre-Existing Conditions limitations.<br /><br />This coverage does not constitute comprehensive health insurance (often referred to as “major medical coverage”) and does not satisfy the requirement for Minimum Essential Coverage under the Affordable Care Act.<br /><br />Group insurance policies are underwritten by Sun Life Assurance Company of Canada (Wellesley Hills, MA) in all states, except New York, under Policy Form Series 93P-LH, 15-GP-01, 12-DI-C-01, 12-GPPort-P-01, 12-STDPort-C-01, 16-DI-C-01, TDBPOLICY-2006, and TDI-POLICY.Product offerings may not be available in all states and may vary depending on state laws and regulations. ",
            },
          },
        },
        default: {
          default: {
            default: {
              link: "https://www.ssa.gov/news/press/factsheets/basicfact-alt.pdf",
              content:
                "1. <0>https://www.ssa.gov/news/press/factsheets/basicfact-alt.pdf</0> (accessed 04/21)<br /><br />2. In Vermont, the product name is Short-Term Income Replacement Insurance when the Maximum Benefit Duration elected is less than 26 weeks.<br /><br />3. Keep in mind that other sources of income could reduce your benefit amount.",
            },
          },
        },
      },
    },
    LONG_TERM_DISABILITY: {
      header: "Long-Term Disability Insurance",
      disclaimer: {
        "Sun Life": {
          default: {
            NY: {
              link: "http://disabilitycanhappen.org",
              content:
                '1. "Chances of disability," Council for Disability Awareness, <0>http://disabilitycanhappen.org</0>, last accessed April 2021.<br /><br />2. Keep in mind that other sources of income could reduce your benefit amount. <br /><br />This policy contains limitations and exclusions that may affect benefits. Please see the Certificate or ask your benefits administrator for information on Elimination Periods, Waiting Periods, and Pre-Existing Conditions limitations.<br /><br />This coverage does not constitute comprehensive health insurance (often referred to as “major medical coverage”) and does not satisfy the requirement for Minimum Essential Coverage under the Affordable Care Act.<br /><br />The group insurance policies described in this advertisement provide disability income insurance only. They do NOT provide basic hospital, basic medical, or major medical insurance as defined by the New York State Department of Financial Services. In New York, the expected benefit ratio for this policy is 66%.<br /><br />In New York, group insurance policies are underwritten by Sun Life and Health Insurance Company (U.S.) (Lansing, MI) under Policy Form Series 15-GP-01, 13-GP-LH-01, 13-LTD-C-01, 13-STD-C-01, 06P-NY-DBL, 12-GPPort-01, and 12-STDPort-C-01. Product offerings may not be available in all states and may vary depending on state laws and regulations.',
            },
            default: {
              link: "http://disabilitycanhappen.org",
              content:
                '1. "Chances of disability," Council for Disability Awareness, <0>http://disabilitycanhappen.org</0>, last accessed April 2021.<br /><br />2. Keep in mind that other sources of income could reduce your benefit amount. <br /><br />This policy contains limitations and exclusions that may affect benefits. Please see the Certificate or ask your benefits administrator for information on Elimination Periods, Waiting Periods, and Pre-Existing Conditions limitations.<br /><br />This coverage does not constitute comprehensive health insurance (often referred to as “major medical coverage”) and does not satisfy the requirement for Minimum Essential Coverage under the Affordable Care Act.<br /><br />Group insurance policies are underwritten by Sun Life Assurance Company of Canada (Wellesley Hills, MA) in all states, except New York, under Policy Form Series 93P-LH, 15-GP-01, 12-DI-C-01, 12-GPPort-P-01, 12-STDPort-C-01, 16-DI-C-01, TDBPOLICY-2006, and TDI-POLICY. Product offerings may not be available in all states and may vary depending on state laws and regulations. ',
            },
          },
        },
        default: {
          default: {
            default: {
              link: "http://disabilitycanhappen.org",
              content:
                '1. "Chances of disability," Council for Disability Awareness, <0>http://disabilitycanhappen.org</0>, last accessed April 2021.<br /><br />2. Keep in mind that other sources of income could reduce your benefit amount.',
            },
          },
        },
      },
    },
    LIFE: {
      header: "Life Insurance",
      header_add: "Life and Accidental Death & Dismemberment Insurance",
      disclaimer: {
        "Sun Life": {
          default: {
            NY: {
              VAS: "1. Value-added services are offered only on specific lines of coverage and carry a separate charge, which is added to the cost of the insurance. The cost is included in the total amount billed.{{VAS_1}}{{VAS_2}} Sun Life is not responsible or liable for care, services, or advice given by any provider or vendor of the Services. Sun Life reserves the right to discontinue any of the Services at any time.<br /><br />",
              VAS_1:
                " Emergency Travel Assistance is provided by Assist America®. Identity Theft Protection is provided by SecurAssist®, an Assist America program.",
              VAS_2:
                " Online Will Preparation and Claimant Support Services are provided by ComPsych® and are not insurance. ComPsych® is a registered trademark of ComPsych Corporation.",
              content:
                "{{VAS}}This policy contains limitations and exclusions that may affect benefits. Please see the Certificate or ask your benefits administrator for information.<br /><br />In New York, group life insurance policies are underwritten by Sun Life and Health Insurance Company (U.S.) (Lansing, MI) under Policy Form Series 15-GP-01, 13-GP-LF-01, 13-LF-C-01, 12-GPPort-P-01, 13-LFPort-C-01, 15-LF-GP-01, 15-LF-C-01, 12-GPPort-P-01, 15-LFPort-C-01, 13-GP-LH-01 and 13-ADD-C-01. Product offerings may not be available in all states and may vary depending on state laws and regulations.",
            },
            default: {
              VAS: "1. Value-added services are offered only on specific lines of coverage and carry a separate charge, which is added to the cost of the insurance. The cost is included in the total amount billed.{{VAS_1}}{{VAS_2}} Sun Life is not responsible or liable for care, services, or advice given by any provider or vendor of the Services. Sun Life reserves the right to discontinue any of the Services at any time.<br /><br />",
              VAS_1:
                " Emergency Travel Assistance is provided by Assist America®. Identity Theft Protection is provided by SecurAssist®, an Assist America program.",
              VAS_2:
                " Online Will Preparation and Claimant Support Services are provided by ComPsych® and are not insurance. ComPsych® is a registered trademark of ComPsych Corporation.",
              content:
                "{{VAS}}This policy contains limitations and exclusions that may affect benefits. Please see the Certificate or ask your benefits administrator for information.<br /><br />Group life insurance policies are underwritten by Sun Life Assurance Company of Canada (Wellesley Hills, MA) in all states, except New York, under Policy Form Series 93P-LH, 98P-ADD, 12-GP-01, 15-GP-01, 15-LF-C-01, 12-GPPort-P-01, 15-LFPort-C-01, 15-ADD-C-01, 13-ADD-C-01 and 13-ADDPort-C-01. Product offerings may not be available in all states and may vary depending on state laws and regulations.",
            },
          },
        },
      },
    },
  },
  ExplorerHeadline: {
    header: "You have access to benefits this year through {{clientName}}.",
    header_one:
      "You have access to <strong>{{count}} benefit</strong> this year through {{clientName}}.",
    header_other:
      "You have access to <strong>{{count}} benefits</strong> this year through {{clientName}}.",
    header_maintenance: "Site down for maintenance",
    header_before: "Come back on {{startsAt, longMonthDayYearDate}}",
    header_after: "Site has expired",
    header_deleted: "The Benefits Explorer site you’re trying to reach is no longer available",
    subHeader:
      "Use this site to learn about benefits from your employer. You can create your own Personal Benefits Plan by favoriting plans below.",
    subHeader_maintenance:
      "We apologize for any inconvenience while the site is down for maintenance. Please check back in shortly.",
    subHeader_before:
      "Benefits Explorer is not yet ready for you to use. Please come back soon to learn about the benefits being offered to you.",
    subHeader_after: "Benefits Explorer is no longer active.",
    subHeader_deleted:
      "Reach out to your employer’s HR department if you need help getting the right link or benefits information. If you're an employer looking for Benefits Explorer site status or help, reach out to <0>support@onboard.sunlife.com</0>.",
  },
  ExplorerCountdown: {
    header: "Enrollment is open!",
    header_past: "Enrollment is closed",
    header_future: "Days until enrollment",
    subheader:
      "You have until <strong>{{date, longMonthDayLongDate}}</strong> to review your <br/> benefits and enroll.",
    subheader_past:
      "<0>Your enrollment closed on <strong>{{date, longMonthDayLongDate}}</strong>.</0><0>New employee? You can learn about the available benefits here, and then sign in and enroll when you're ready.</0>",
    subheader_future:
      "If you'd like a reminder of when your enrollment begins, sign up for text notifications.",
    callToAction: "Sign in & enroll",
    callToAction_past: "Sign in & enroll",
    callToAction_future: "Get text notifications",
    callToAction_externalLink: "View enrollment options",
    callToAction_nobenefits: "Sign in",
    newSiteMessage_past:
      "But don't worry, we've got you covered. Visit your new enrollment site below.",
    newSiteMessage_future:
      "<0>Your enrollment closed on <strong>{{date, longMonthDayLongDate}}</strong>.</0><0>New employee? You can learn about the available benefits here, and then sign in and enroll when you're ready.</0>",
    callToAction_NewSite: "Go to new site",
  },
  ExplorerMenuMobile: {
    benAdminCallToAction: "Sign in & Enroll",
  },
  ExplorerNavBar: {
    benAdminCallToAction: "Sign in & Enroll",
    personalPlanCallToAction: "({{count}}) Personal Benefits Plan",
    benAdminCallToAction_externalLink: "View enrollment options",
    benAdminCallToActionNoBenefits: "Sign in",
    demoBannerBody: "You’re viewing a demo site.",
    enrollmentStatus: "{{currentDemoStatus, capitalize}}enrollment",
    english: "English",
    spanish: "Español",
    leadGenerationBody: "Want a custom Benefits Explorer site for your employees?",
    leadGenerationLink: "Let us know",
  },
  PersonalBenefitsFavoritePlans: {
    benefitLink: "Back to benefit",
  },
  ExplorerNeedGuidance: {
    heading: "Need more guidance? Sun Life Benefit Counselors are here to help.",
    content:
      "Benefit Counselors are available M-F, 8 a.m.- 8 p.m., Eastern Time (ET). Holiday schedules may vary.",
    callToAction: "Chat now",
  },
  ExplorerFeedbackForm: {
    body: "<strong>How are we doing?</strong> Please rate our experience on a scale of 1-5 stars.",
    feedbackLabel: "Please tell us why you rated it this way.",
    callToAction: "Submit Feedback",
    cancel: "Cancel",
    success: "Your feedback has been recorded.",
  },
  ExplorerHighlighters: {
    title: "Highlights this year",
    callToAction: "View {{more}} more",
    modalTitle: "New this year",
  },
  ExplorerLanguage: {
    heading: "Language preference",
    preferredLangugageWarning:
      "We have made every effort to translate your benefit information into your preferred language. See our Terms and Conditions for more information.",
    saveButton: "Submit",
  },
  ExplorerLeadGeneration: {
    heading: "Request Benefits Explorer",
    content:
      "Thanks for your interest! Please fill out the fields below so that we can contact you about creating a Benefits Explorer site for your employees.",
    confirmHeading: "Thank you",
    confirmContent: "Your request has been received.",
    submit: "Submit",
    cancel: "Cancel",
    close: "Close",
  },
  ExplorerBenefitsNames: {
    MEDICAL: "Medical",
    DENTAL: "Dental",
    VISION: "Vision",
    CRITICAL_ILLNESS: "Critical Illness",
    ACCIDENT: "Accident",
    HOSPITAL_INDEMNITY: "Hospital Indemnity",
    CANCER: "Cancer",
    GAP: "Gap",
    SHORT_TERM_DISABILITY: "Short-Term Disability",
    LONG_TERM_DISABILITY: "Long-Term Disability",
    LIFE: "Life",
    OTHER_one: "Additional Benefit",
    OTHER_other: "Additional Benefits",
    FINANCIAL: "Financial Products",
  },
  ExplorerGiveFeedback: {
    feedbackBtnText: "Give Feedback",
  },
  ExplorerNewSiteModal: {
    header_not_expired: "A new site is available",
    content_not_expired: `
      <p>There's an updated website where you can learn about your {{clientName}} benefits for {{planYear}}.</p>
      <p>To learn about benefits for the current benefits season, please visit the new site.</p>
      `,
    header_expired: "This site is out of date",
    content_expired: `
        <p>You have access to benefits for {{planYear}} through {{clientName}}. This benefits site is out of date.</p>
        <p>Please go to the new site for the most up to date information.</p>
        `,
    callToAction_NewSite: "Go to new site",
    callToAction_CurrentSite: "Stay on current site",
  },
  ExplorerContactUs: {
    how_to_contact_us: "How to contact us",
    we_are_here_to_help: "We're here to help",
    send_message_by_email: "Send a message by email",
    schedule_appointment: "Schedule a 1:1 appointment",
    chat_with_counselor:
      "Chat with a benefit counselor on this page Monday through Friday between the hours of 8 AM and 8 PM ET",
    contact_us: "Contact Us",
  },
  HospitalIndemnityDisclosure: {
    disclosure: {
      heading: "IMPORTANT: This is a fixed indemnity policy, NOT health insurance",
      description:
        "This fixed indemnity policy may pay you a limited dollar amount if you're sick or hospitalized. You're still responsible for paying the cost of your care.",
      listItems: [
        "The payment you get isn't based on the size of your medical bill.",
        "There might be a limit on how much this policy will pay each year.",
        "This policy isn't a substitute for comprehensive health insurance.",
        "Since this policy isn't health insurance, it doesn't have to include most Federal consumer protections that apply to health insurance.",
      ],
    },
    lookingFor: {
      heading: "Looking for comprehensive health insurance?",
      listItems: [
        `Visit <0>HealthCare.gov</0> online or call 1-800-318-2596 (TTY: 1-855-889-4325) to find health coverage options.`,
        "To find out if you can get health insurance through your job, or a family member's job, contact the employer.",
      ],
    },
    questions: {
      heading: "Questions about this policy?",
      listItems: [
        `For questions or complaints about this policy, contact your State Department of Insurance. Find their number on the National Association of Insurance Commissioners' website (<0>naic.org</0>) under “Insurance Departments.”`,
        "If you have this policy through your job, or a family member's job, contact the employer.",
      ],
    },
  },
} satisfies Record<string, unknown> & {
  Generic: { Yes: string; No: string };
  ExplorerBenefitHowToUsePlan: ExplorerBenefitHowToUsePlanCopyStructure;
  ExplorerBenefitFaq: ExplorerBenefitFaqCopyStructure;
  ExplorerDisclaimers: ExplorerDisclaimersCopyStructure;
  ExplorerBenefit: ExplorerBenefitCopyStructure;
  ExplorerPlan: ExplorerPlanCopyStructure;
  ExplorerHeadline: ExplorerHeadlineCopyStructure;
  ExplorerBenefitVideo: ExplorerBenefitVideoCopyStructure;
  ExplorerBenefitHelpfulHint: ExplorerBenefitHelpfulHintCopyStrucutre;
  ExplorerPlanComparisonTable: ExplorerPlanComparisonTableCopyStructure;
  ExplorerPlanComparisonTableWVClientDental: ExplorerPlanComparisonTableWVClientDentalCopyStructure;
  ExplorerBenefitRealWorld: ExplorerBenefitRealWorldCopyStructure;
  ExplorerHighlighters: ExplorerHighlightersCopyStructure;
  PersonalBenefitsPlanHeadline: PersonalBenefitsPlanHeadlineCopyStructure;
  ExplorerLocationModal: ExplorerLocationModalCopyStructure;
  ExplorerBenefitOverview: ExplorerBenefitOverviewCopyStrucutre;
  ExplorerBenefitWhyNeedIt: ExplorerBenefitWhyNeedItCopyStructure;
  ExplorerBenefitPlans: ExplorerBenefitPlansCopyStructure;
  ExplorerBenefitFindDoctor: ExplorerBenefitFindDoctorCopyStructure;
  ExplorerBenefitHowMuchCoverage: ExplorerBenefitHowMuchCoverageCopyStructure;
  ExplorerBenefitCoverageCalculator: ExplorerBenefitCoverageCalculatorCopyStrucutre;
  ExplorerBenefitADD: ExplorerBenefitADDCopyStructure;
  ExplorerBenefitWellness: ExplorerBenefitWellnessCopyStructure;
  ExplorerNavBar: ExplorerNavBarCopyStructure;
  ExplorerLeadGeneration: ExplorerLeadGenerationCopyStructure;
  ExplorerNewSiteModal: ExplorerNewSiteModalCopyStructure;
};
